/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ConfirmEmailChangeRouteImport } from './routes/confirm-email-change'
import { Route as AcceptInviteRouteImport } from './routes/accept-invite'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as AuthIndexRouteImport } from './routes/_auth.index'
import { Route as AuthPasswordResetRouteImport } from './routes/auth.password-reset'
import { Route as AuthWriteoffRouteImport } from './routes/_auth.writeoff'
import { Route as AuthWorkBlueprintsRouteImport } from './routes/_auth.work-blueprints'
import { Route as AuthWarehousesRouteImport } from './routes/_auth.warehouses'
import { Route as AuthReconciliationRouteImport } from './routes/_auth.reconciliation'
import { Route as AuthPeriodCloseRouteImport } from './routes/_auth.period-close'
import { Route as AuthNotificationsRouteImport } from './routes/_auth.notifications'
import { Route as AuthMyDayRouteImport } from './routes/_auth.my-day'
import { Route as AuthForcePasswordChangeRouteImport } from './routes/_auth.force-password-change'
import { Route as AuthExcelRouteImport } from './routes/_auth.excel'
import { Route as AuthEvidenceRouteImport } from './routes/_auth.evidence'
import { Route as AuthDesignSystemRouteImport } from './routes/_auth.design-system'
import { Route as AuthCostRouteImport } from './routes/_auth.cost'
import { Route as AuthConflictsRouteImport } from './routes/_auth.conflicts'
import { Route as AuthChatRouteImport } from './routes/_auth.chat'
import { Route as AuthBatchesRouteImport } from './routes/_auth.batches'
import { Route as AuthApprovalsRouteImport } from './routes/_auth.approvals'
import { Route as AuthAnomaliesRouteImport } from './routes/_auth.anomalies'
import { Route as AuthAdminRouteImport } from './routes/_auth.admin'
import { Route as AuthWorkTasksIndexRouteImport } from './routes/_auth.work-tasks.index'
import { Route as AuthWorkOrdersIndexRouteImport } from './routes/_auth.work-orders.index'
import { Route as AuthStockReconciliationIndexRouteImport } from './routes/_auth.stock-reconciliation.index'
import { Route as AuthStockEntriesIndexRouteImport } from './routes/_auth.stock-entries.index'
import { Route as AuthSettlementsIndexRouteImport } from './routes/_auth.settlements.index'
import { Route as AuthSalesOrdersIndexRouteImport } from './routes/_auth.sales-orders.index'
import { Route as AuthRunsIndexRouteImport } from './routes/_auth.runs.index'
import { Route as AuthProjectsIndexRouteImport } from './routes/_auth.projects.index'
import { Route as AuthPaymentsIndexRouteImport } from './routes/_auth.payments.index'
import { Route as AuthLandedCostIndexRouteImport } from './routes/_auth.landed-cost.index'
import { Route as AuthItemsIndexRouteImport } from './routes/_auth.items.index'
import { Route as AuthDocsIndexRouteImport } from './routes/_auth.docs.index'
import { Route as AuthCounterpartiesIndexRouteImport } from './routes/_auth.counterparties.index'
import { Route as AuthBudgetsIndexRouteImport } from './routes/_auth.budgets.index'
import { Route as AuthBomsIndexRouteImport } from './routes/_auth.boms.index'
import { Route as AuthAdminIndexRouteImport } from './routes/_auth.admin.index'
import { Route as AuthWorkTasksProjectIdRouteImport } from './routes/_auth.work-tasks.$projectId'
import { Route as AuthWorkOrdersNewRouteImport } from './routes/_auth.work-orders.new'
import { Route as AuthWorkBlueprintsIdRouteImport } from './routes/_auth.work-blueprints_.$id'
import { Route as AuthStockLedgerRouteImport } from './routes/_auth.stock.ledger'
import { Route as AuthStockBalanceRouteImport } from './routes/_auth.stock.balance'
import { Route as AuthStockReconciliationNewRouteImport } from './routes/_auth.stock-reconciliation.new'
import { Route as AuthStockEntriesNewRouteImport } from './routes/_auth.stock-entries.new'
import { Route as AuthSettlementsNewRouteImport } from './routes/_auth.settlements.new'
import { Route as AuthSalesOrdersNewRouteImport } from './routes/_auth.sales-orders.new'
import { Route as AuthRunsRunIdRouteImport } from './routes/_auth.runs.$runId'
import { Route as AuthProjectsNewRouteImport } from './routes/_auth.projects.new'
import { Route as AuthPaymentsNewRouteImport } from './routes/_auth.payments.new'
import { Route as AuthOnboardingStepRouteImport } from './routes/_auth.onboarding.$step'
import { Route as AuthMeTaskNotificationsRouteImport } from './routes/_auth.me.task-notifications'
import { Route as AuthMePreferencesRouteImport } from './routes/_auth.me.preferences'
import { Route as AuthLandedCostNewRouteImport } from './routes/_auth.landed-cost.new'
import { Route as AuthItemsItemIdRouteImport } from './routes/_auth.items.$itemId'
import { Route as AuthInvoicesNewRouteImport } from './routes/_auth.invoices.new'
import { Route as AuthInvoicesArRouteImport } from './routes/_auth.invoices.ar'
import { Route as AuthInvoicesApRouteImport } from './routes/_auth.invoices.ap'
import { Route as AuthFinanceTaxSummaryRouteImport } from './routes/_auth.finance.tax-summary'
import { Route as AuthFinanceSnapshotsRouteImport } from './routes/_auth.finance.snapshots'
import { Route as AuthFinancePnlRouteImport } from './routes/_auth.finance.pnl'
import { Route as AuthFinanceOnecPushRouteImport } from './routes/_auth.finance.onec-push'
import { Route as AuthFinanceDashboardRouteImport } from './routes/_auth.finance.dashboard'
import { Route as AuthFinanceCogsRouteImport } from './routes/_auth.finance.cogs'
import { Route as AuthFinanceCashFlowRouteImport } from './routes/_auth.finance.cash-flow'
import { Route as AuthDocsSearchRouteImport } from './routes/_auth.docs.search'
import { Route as AuthCounterpartiesNewRouteImport } from './routes/_auth.counterparties.new'
import { Route as AuthBudgetsNewRouteImport } from './routes/_auth.budgets.new'
import { Route as AuthBomsNewRouteImport } from './routes/_auth.boms.new'
import { Route as AuthBomsBomIdRouteImport } from './routes/_auth.boms.$bomId'
import { Route as AuthAdminWarehouseAccessRouteImport } from './routes/_auth.admin.warehouse-access'
import { Route as AuthAdminUsersRouteImport } from './routes/_auth.admin.users'
import { Route as AuthAdminTaskAutomationRouteImport } from './routes/_auth.admin.task-automation'
import { Route as AuthAdminSyncStagingRouteImport } from './routes/_auth.admin.sync-staging'
import { Route as AuthAdminMemoryRouteImport } from './routes/_auth.admin.memory'
import { Route as AuthAdminJobsRouteImport } from './routes/_auth.admin.jobs'
import { Route as AuthAdminIntegrationsRouteImport } from './routes/_auth.admin.integrations'
import { Route as AuthAdminHoldingsRouteImport } from './routes/_auth.admin.holdings'
import { Route as AuthAdminFxRatesRouteImport } from './routes/_auth.admin.fx-rates'
import { Route as AuthAdminEntitiesRouteImport } from './routes/_auth.admin.entities'
import { Route as AuthAdminEmailTemplatesRouteImport } from './routes/_auth.admin.email-templates'
import { Route as AuthAdminBankImportRouteImport } from './routes/_auth.admin.bank-import'
import { Route as AuthAdminAuditRouteImport } from './routes/_auth.admin.audit'
import { Route as AuthAdminApprovalMatrixRouteImport } from './routes/_auth.admin.approval-matrix'
import { Route as AuthWorkOrdersIdIndexRouteImport } from './routes/_auth.work-orders.$id.index'
import { Route as AuthStockReconciliationIdIndexRouteImport } from './routes/_auth.stock-reconciliation.$id.index'
import { Route as AuthStockEntriesIdIndexRouteImport } from './routes/_auth.stock-entries.$id.index'
import { Route as AuthSettlementsIdIndexRouteImport } from './routes/_auth.settlements.$id.index'
import { Route as AuthSalesOrdersIdIndexRouteImport } from './routes/_auth.sales-orders.$id.index'
import { Route as AuthProjectsIdIndexRouteImport } from './routes/_auth.projects.$id.index'
import { Route as AuthPaymentsIdIndexRouteImport } from './routes/_auth.payments.$id.index'
import { Route as AuthLandedCostIdIndexRouteImport } from './routes/_auth.landed-cost.$id.index'
import { Route as AuthInvoicesIdIndexRouteImport } from './routes/_auth.invoices.$id.index'
import { Route as AuthFinanceKpnIndexRouteImport } from './routes/_auth.finance.kpn.index'
import { Route as AuthFinanceEsfIndexRouteImport } from './routes/_auth.finance.esf.index'
import { Route as AuthDocsRoleIndexRouteImport } from './routes/_auth.docs.$role.index'
import { Route as AuthCounterpartiesIdIndexRouteImport } from './routes/_auth.counterparties.$id.index'
import { Route as AuthBudgetsIdIndexRouteImport } from './routes/_auth.budgets.$id.index'
import { Route as AuthWorkTasksTaskTaskIdRouteImport } from './routes/_auth.work-tasks.task.$taskId'
import { Route as AuthWorkOrdersIdEditRouteImport } from './routes/_auth.work-orders.$id.edit'
import { Route as AuthWorkBlueprintsIdEditRouteImport } from './routes/_auth.work-blueprints_.$id_.edit'
import { Route as AuthStockReconciliationIdEditRouteImport } from './routes/_auth.stock-reconciliation.$id.edit'
import { Route as AuthStockEntriesIdEditRouteImport } from './routes/_auth.stock-entries.$id.edit'
import { Route as AuthSettlementsIdEditRouteImport } from './routes/_auth.settlements.$id.edit'
import { Route as AuthSalesOrdersIdEditRouteImport } from './routes/_auth.sales-orders.$id.edit'
import { Route as AuthProjectsIdEditRouteImport } from './routes/_auth.projects.$id.edit'
import { Route as AuthPaymentsIdEditRouteImport } from './routes/_auth.payments.$id.edit'
import { Route as AuthLandedCostIdEditRouteImport } from './routes/_auth.landed-cost.$id.edit'
import { Route as AuthInvoicesArNewRouteImport } from './routes/_auth.invoices.ar.new'
import { Route as AuthInvoicesApNewRouteImport } from './routes/_auth.invoices.ap.new'
import { Route as AuthInvoicesIdEditRouteImport } from './routes/_auth.invoices.$id.edit'
import { Route as AuthFinanceRegulatoryKpnRouteImport } from './routes/_auth.finance.regulatory.kpn'
import { Route as AuthFinanceRegulatoryEsfRouteImport } from './routes/_auth.finance.regulatory.esf'
import { Route as AuthFinanceKpnIdRouteImport } from './routes/_auth.finance.kpn.$id'
import { Route as AuthFinanceEsfIdRouteImport } from './routes/_auth.finance.esf.$id'
import { Route as AuthCounterpartiesIdEditRouteImport } from './routes/_auth.counterparties.$id.edit'
import { Route as AuthBudgetsIdEditRouteImport } from './routes/_auth.budgets.$id.edit'
import { Route as AuthAdminIntegrationsPlatformRouteImport } from './routes/_auth.admin.integrations_.platform'
import { Route as AuthAdminHoldingsHoldingIdRouteImport } from './routes/_auth.admin.holdings_.$holdingId'
import { Route as AuthAdminEntitiesEntityIdRouteImport } from './routes/_auth.admin.entities_.$entityId'
import { Route as AuthDocsRoleSlugIndexRouteImport } from './routes/_auth.docs.$role.$slug.index'
import { Route as AuthWorkTasksProjectIdTaskTaskIdRouteImport } from './routes/_auth.work-tasks.$projectId_.task.$taskId'
import { Route as AuthDocsRoleSlugHistoryRouteImport } from './routes/_auth.docs.$role.$slug.history'
import { Route as AuthDocsRoleSlugEditRouteImport } from './routes/_auth.docs.$role.$slug.edit'
import { Route as AuthAdminUsersUserIdMembershipsRouteImport } from './routes/_auth.admin.users_.$userId.memberships'
import { Route as AuthAdminIntegrationsConnectionsIdRouteImport } from './routes/_auth.admin.integrations_.connections.$id'

const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const ConfirmEmailChangeRoute = ConfirmEmailChangeRouteImport.update({
  id: '/confirm-email-change',
  path: '/confirm-email-change',
  getParentRoute: () => rootRouteImport,
} as any)
const AcceptInviteRoute = AcceptInviteRouteImport.update({
  id: '/accept-invite',
  path: '/accept-invite',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthIndexRoute = AuthIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthPasswordResetRoute = AuthPasswordResetRouteImport.update({
  id: '/auth/password-reset',
  path: '/auth/password-reset',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthWriteoffRoute = AuthWriteoffRouteImport.update({
  id: '/writeoff',
  path: '/writeoff',
  getParentRoute: () => AuthRoute,
} as any)
const AuthWorkBlueprintsRoute = AuthWorkBlueprintsRouteImport.update({
  id: '/work-blueprints',
  path: '/work-blueprints',
  getParentRoute: () => AuthRoute,
} as any)
const AuthWarehousesRoute = AuthWarehousesRouteImport.update({
  id: '/warehouses',
  path: '/warehouses',
  getParentRoute: () => AuthRoute,
} as any)
const AuthReconciliationRoute = AuthReconciliationRouteImport.update({
  id: '/reconciliation',
  path: '/reconciliation',
  getParentRoute: () => AuthRoute,
} as any)
const AuthPeriodCloseRoute = AuthPeriodCloseRouteImport.update({
  id: '/period-close',
  path: '/period-close',
  getParentRoute: () => AuthRoute,
} as any)
const AuthNotificationsRoute = AuthNotificationsRouteImport.update({
  id: '/notifications',
  path: '/notifications',
  getParentRoute: () => AuthRoute,
} as any)
const AuthMyDayRoute = AuthMyDayRouteImport.update({
  id: '/my-day',
  path: '/my-day',
  getParentRoute: () => AuthRoute,
} as any)
const AuthForcePasswordChangeRoute = AuthForcePasswordChangeRouteImport.update({
  id: '/force-password-change',
  path: '/force-password-change',
  getParentRoute: () => AuthRoute,
} as any)
const AuthExcelRoute = AuthExcelRouteImport.update({
  id: '/excel',
  path: '/excel',
  getParentRoute: () => AuthRoute,
} as any)
const AuthEvidenceRoute = AuthEvidenceRouteImport.update({
  id: '/evidence',
  path: '/evidence',
  getParentRoute: () => AuthRoute,
} as any)
const AuthDesignSystemRoute = AuthDesignSystemRouteImport.update({
  id: '/design-system',
  path: '/design-system',
  getParentRoute: () => AuthRoute,
} as any)
const AuthCostRoute = AuthCostRouteImport.update({
  id: '/cost',
  path: '/cost',
  getParentRoute: () => AuthRoute,
} as any)
const AuthConflictsRoute = AuthConflictsRouteImport.update({
  id: '/conflicts',
  path: '/conflicts',
  getParentRoute: () => AuthRoute,
} as any)
const AuthChatRoute = AuthChatRouteImport.update({
  id: '/chat',
  path: '/chat',
  getParentRoute: () => AuthRoute,
} as any)
const AuthBatchesRoute = AuthBatchesRouteImport.update({
  id: '/batches',
  path: '/batches',
  getParentRoute: () => AuthRoute,
} as any)
const AuthApprovalsRoute = AuthApprovalsRouteImport.update({
  id: '/approvals',
  path: '/approvals',
  getParentRoute: () => AuthRoute,
} as any)
const AuthAnomaliesRoute = AuthAnomaliesRouteImport.update({
  id: '/anomalies',
  path: '/anomalies',
  getParentRoute: () => AuthRoute,
} as any)
const AuthAdminRoute = AuthAdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => AuthRoute,
} as any)
const AuthWorkTasksIndexRoute = AuthWorkTasksIndexRouteImport.update({
  id: '/work-tasks/',
  path: '/work-tasks/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthWorkOrdersIndexRoute = AuthWorkOrdersIndexRouteImport.update({
  id: '/work-orders/',
  path: '/work-orders/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthStockReconciliationIndexRoute =
  AuthStockReconciliationIndexRouteImport.update({
    id: '/stock-reconciliation/',
    path: '/stock-reconciliation/',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthStockEntriesIndexRoute = AuthStockEntriesIndexRouteImport.update({
  id: '/stock-entries/',
  path: '/stock-entries/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSettlementsIndexRoute = AuthSettlementsIndexRouteImport.update({
  id: '/settlements/',
  path: '/settlements/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSalesOrdersIndexRoute = AuthSalesOrdersIndexRouteImport.update({
  id: '/sales-orders/',
  path: '/sales-orders/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthRunsIndexRoute = AuthRunsIndexRouteImport.update({
  id: '/runs/',
  path: '/runs/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthProjectsIndexRoute = AuthProjectsIndexRouteImport.update({
  id: '/projects/',
  path: '/projects/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthPaymentsIndexRoute = AuthPaymentsIndexRouteImport.update({
  id: '/payments/',
  path: '/payments/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthLandedCostIndexRoute = AuthLandedCostIndexRouteImport.update({
  id: '/landed-cost/',
  path: '/landed-cost/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthItemsIndexRoute = AuthItemsIndexRouteImport.update({
  id: '/items/',
  path: '/items/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthDocsIndexRoute = AuthDocsIndexRouteImport.update({
  id: '/docs/',
  path: '/docs/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthCounterpartiesIndexRoute = AuthCounterpartiesIndexRouteImport.update({
  id: '/counterparties/',
  path: '/counterparties/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthBudgetsIndexRoute = AuthBudgetsIndexRouteImport.update({
  id: '/budgets/',
  path: '/budgets/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthBomsIndexRoute = AuthBomsIndexRouteImport.update({
  id: '/boms/',
  path: '/boms/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthAdminIndexRoute = AuthAdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthAdminRoute,
} as any)
const AuthWorkTasksProjectIdRoute = AuthWorkTasksProjectIdRouteImport.update({
  id: '/work-tasks/$projectId',
  path: '/work-tasks/$projectId',
  getParentRoute: () => AuthRoute,
} as any)
const AuthWorkOrdersNewRoute = AuthWorkOrdersNewRouteImport.update({
  id: '/work-orders/new',
  path: '/work-orders/new',
  getParentRoute: () => AuthRoute,
} as any)
const AuthWorkBlueprintsIdRoute = AuthWorkBlueprintsIdRouteImport.update({
  id: '/work-blueprints_/$id',
  path: '/work-blueprints/$id',
  getParentRoute: () => AuthRoute,
} as any)
const AuthStockLedgerRoute = AuthStockLedgerRouteImport.update({
  id: '/stock/ledger',
  path: '/stock/ledger',
  getParentRoute: () => AuthRoute,
} as any)
const AuthStockBalanceRoute = AuthStockBalanceRouteImport.update({
  id: '/stock/balance',
  path: '/stock/balance',
  getParentRoute: () => AuthRoute,
} as any)
const AuthStockReconciliationNewRoute =
  AuthStockReconciliationNewRouteImport.update({
    id: '/stock-reconciliation/new',
    path: '/stock-reconciliation/new',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthStockEntriesNewRoute = AuthStockEntriesNewRouteImport.update({
  id: '/stock-entries/new',
  path: '/stock-entries/new',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSettlementsNewRoute = AuthSettlementsNewRouteImport.update({
  id: '/settlements/new',
  path: '/settlements/new',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSalesOrdersNewRoute = AuthSalesOrdersNewRouteImport.update({
  id: '/sales-orders/new',
  path: '/sales-orders/new',
  getParentRoute: () => AuthRoute,
} as any)
const AuthRunsRunIdRoute = AuthRunsRunIdRouteImport.update({
  id: '/runs/$runId',
  path: '/runs/$runId',
  getParentRoute: () => AuthRoute,
} as any)
const AuthProjectsNewRoute = AuthProjectsNewRouteImport.update({
  id: '/projects/new',
  path: '/projects/new',
  getParentRoute: () => AuthRoute,
} as any)
const AuthPaymentsNewRoute = AuthPaymentsNewRouteImport.update({
  id: '/payments/new',
  path: '/payments/new',
  getParentRoute: () => AuthRoute,
} as any)
const AuthOnboardingStepRoute = AuthOnboardingStepRouteImport.update({
  id: '/onboarding/$step',
  path: '/onboarding/$step',
  getParentRoute: () => AuthRoute,
} as any)
const AuthMeTaskNotificationsRoute = AuthMeTaskNotificationsRouteImport.update({
  id: '/me/task-notifications',
  path: '/me/task-notifications',
  getParentRoute: () => AuthRoute,
} as any)
const AuthMePreferencesRoute = AuthMePreferencesRouteImport.update({
  id: '/me/preferences',
  path: '/me/preferences',
  getParentRoute: () => AuthRoute,
} as any)
const AuthLandedCostNewRoute = AuthLandedCostNewRouteImport.update({
  id: '/landed-cost/new',
  path: '/landed-cost/new',
  getParentRoute: () => AuthRoute,
} as any)
const AuthItemsItemIdRoute = AuthItemsItemIdRouteImport.update({
  id: '/items/$itemId',
  path: '/items/$itemId',
  getParentRoute: () => AuthRoute,
} as any)
const AuthInvoicesNewRoute = AuthInvoicesNewRouteImport.update({
  id: '/invoices/new',
  path: '/invoices/new',
  getParentRoute: () => AuthRoute,
} as any)
const AuthInvoicesArRoute = AuthInvoicesArRouteImport.update({
  id: '/invoices/ar',
  path: '/invoices/ar',
  getParentRoute: () => AuthRoute,
} as any)
const AuthInvoicesApRoute = AuthInvoicesApRouteImport.update({
  id: '/invoices/ap',
  path: '/invoices/ap',
  getParentRoute: () => AuthRoute,
} as any)
const AuthFinanceTaxSummaryRoute = AuthFinanceTaxSummaryRouteImport.update({
  id: '/finance/tax-summary',
  path: '/finance/tax-summary',
  getParentRoute: () => AuthRoute,
} as any)
const AuthFinanceSnapshotsRoute = AuthFinanceSnapshotsRouteImport.update({
  id: '/finance/snapshots',
  path: '/finance/snapshots',
  getParentRoute: () => AuthRoute,
} as any)
const AuthFinancePnlRoute = AuthFinancePnlRouteImport.update({
  id: '/finance/pnl',
  path: '/finance/pnl',
  getParentRoute: () => AuthRoute,
} as any)
const AuthFinanceOnecPushRoute = AuthFinanceOnecPushRouteImport.update({
  id: '/finance/onec-push',
  path: '/finance/onec-push',
  getParentRoute: () => AuthRoute,
} as any)
const AuthFinanceDashboardRoute = AuthFinanceDashboardRouteImport.update({
  id: '/finance/dashboard',
  path: '/finance/dashboard',
  getParentRoute: () => AuthRoute,
} as any)
const AuthFinanceCogsRoute = AuthFinanceCogsRouteImport.update({
  id: '/finance/cogs',
  path: '/finance/cogs',
  getParentRoute: () => AuthRoute,
} as any)
const AuthFinanceCashFlowRoute = AuthFinanceCashFlowRouteImport.update({
  id: '/finance/cash-flow',
  path: '/finance/cash-flow',
  getParentRoute: () => AuthRoute,
} as any)
const AuthDocsSearchRoute = AuthDocsSearchRouteImport.update({
  id: '/docs/search',
  path: '/docs/search',
  getParentRoute: () => AuthRoute,
} as any)
const AuthCounterpartiesNewRoute = AuthCounterpartiesNewRouteImport.update({
  id: '/counterparties/new',
  path: '/counterparties/new',
  getParentRoute: () => AuthRoute,
} as any)
const AuthBudgetsNewRoute = AuthBudgetsNewRouteImport.update({
  id: '/budgets/new',
  path: '/budgets/new',
  getParentRoute: () => AuthRoute,
} as any)
const AuthBomsNewRoute = AuthBomsNewRouteImport.update({
  id: '/boms/new',
  path: '/boms/new',
  getParentRoute: () => AuthRoute,
} as any)
const AuthBomsBomIdRoute = AuthBomsBomIdRouteImport.update({
  id: '/boms/$bomId',
  path: '/boms/$bomId',
  getParentRoute: () => AuthRoute,
} as any)
const AuthAdminWarehouseAccessRoute =
  AuthAdminWarehouseAccessRouteImport.update({
    id: '/warehouse-access',
    path: '/warehouse-access',
    getParentRoute: () => AuthAdminRoute,
  } as any)
const AuthAdminUsersRoute = AuthAdminUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AuthAdminRoute,
} as any)
const AuthAdminTaskAutomationRoute = AuthAdminTaskAutomationRouteImport.update({
  id: '/task-automation',
  path: '/task-automation',
  getParentRoute: () => AuthAdminRoute,
} as any)
const AuthAdminSyncStagingRoute = AuthAdminSyncStagingRouteImport.update({
  id: '/sync-staging',
  path: '/sync-staging',
  getParentRoute: () => AuthAdminRoute,
} as any)
const AuthAdminMemoryRoute = AuthAdminMemoryRouteImport.update({
  id: '/memory',
  path: '/memory',
  getParentRoute: () => AuthAdminRoute,
} as any)
const AuthAdminJobsRoute = AuthAdminJobsRouteImport.update({
  id: '/jobs',
  path: '/jobs',
  getParentRoute: () => AuthAdminRoute,
} as any)
const AuthAdminIntegrationsRoute = AuthAdminIntegrationsRouteImport.update({
  id: '/integrations',
  path: '/integrations',
  getParentRoute: () => AuthAdminRoute,
} as any)
const AuthAdminHoldingsRoute = AuthAdminHoldingsRouteImport.update({
  id: '/holdings',
  path: '/holdings',
  getParentRoute: () => AuthAdminRoute,
} as any)
const AuthAdminFxRatesRoute = AuthAdminFxRatesRouteImport.update({
  id: '/fx-rates',
  path: '/fx-rates',
  getParentRoute: () => AuthAdminRoute,
} as any)
const AuthAdminEntitiesRoute = AuthAdminEntitiesRouteImport.update({
  id: '/entities',
  path: '/entities',
  getParentRoute: () => AuthAdminRoute,
} as any)
const AuthAdminEmailTemplatesRoute = AuthAdminEmailTemplatesRouteImport.update({
  id: '/email-templates',
  path: '/email-templates',
  getParentRoute: () => AuthAdminRoute,
} as any)
const AuthAdminBankImportRoute = AuthAdminBankImportRouteImport.update({
  id: '/bank-import',
  path: '/bank-import',
  getParentRoute: () => AuthAdminRoute,
} as any)
const AuthAdminAuditRoute = AuthAdminAuditRouteImport.update({
  id: '/audit',
  path: '/audit',
  getParentRoute: () => AuthAdminRoute,
} as any)
const AuthAdminApprovalMatrixRoute = AuthAdminApprovalMatrixRouteImport.update({
  id: '/approval-matrix',
  path: '/approval-matrix',
  getParentRoute: () => AuthAdminRoute,
} as any)
const AuthWorkOrdersIdIndexRoute = AuthWorkOrdersIdIndexRouteImport.update({
  id: '/work-orders/$id/',
  path: '/work-orders/$id/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthStockReconciliationIdIndexRoute =
  AuthStockReconciliationIdIndexRouteImport.update({
    id: '/stock-reconciliation/$id/',
    path: '/stock-reconciliation/$id/',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthStockEntriesIdIndexRoute = AuthStockEntriesIdIndexRouteImport.update({
  id: '/stock-entries/$id/',
  path: '/stock-entries/$id/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSettlementsIdIndexRoute = AuthSettlementsIdIndexRouteImport.update({
  id: '/settlements/$id/',
  path: '/settlements/$id/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSalesOrdersIdIndexRoute = AuthSalesOrdersIdIndexRouteImport.update({
  id: '/sales-orders/$id/',
  path: '/sales-orders/$id/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthProjectsIdIndexRoute = AuthProjectsIdIndexRouteImport.update({
  id: '/projects/$id/',
  path: '/projects/$id/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthPaymentsIdIndexRoute = AuthPaymentsIdIndexRouteImport.update({
  id: '/payments/$id/',
  path: '/payments/$id/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthLandedCostIdIndexRoute = AuthLandedCostIdIndexRouteImport.update({
  id: '/landed-cost/$id/',
  path: '/landed-cost/$id/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthInvoicesIdIndexRoute = AuthInvoicesIdIndexRouteImport.update({
  id: '/invoices/$id/',
  path: '/invoices/$id/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthFinanceKpnIndexRoute = AuthFinanceKpnIndexRouteImport.update({
  id: '/finance/kpn/',
  path: '/finance/kpn/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthFinanceEsfIndexRoute = AuthFinanceEsfIndexRouteImport.update({
  id: '/finance/esf/',
  path: '/finance/esf/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthDocsRoleIndexRoute = AuthDocsRoleIndexRouteImport.update({
  id: '/docs/$role/',
  path: '/docs/$role/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthCounterpartiesIdIndexRoute =
  AuthCounterpartiesIdIndexRouteImport.update({
    id: '/counterparties/$id/',
    path: '/counterparties/$id/',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthBudgetsIdIndexRoute = AuthBudgetsIdIndexRouteImport.update({
  id: '/budgets/$id/',
  path: '/budgets/$id/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthWorkTasksTaskTaskIdRoute = AuthWorkTasksTaskTaskIdRouteImport.update({
  id: '/work-tasks/task/$taskId',
  path: '/work-tasks/task/$taskId',
  getParentRoute: () => AuthRoute,
} as any)
const AuthWorkOrdersIdEditRoute = AuthWorkOrdersIdEditRouteImport.update({
  id: '/work-orders/$id/edit',
  path: '/work-orders/$id/edit',
  getParentRoute: () => AuthRoute,
} as any)
const AuthWorkBlueprintsIdEditRoute =
  AuthWorkBlueprintsIdEditRouteImport.update({
    id: '/work-blueprints_/$id_/edit',
    path: '/work-blueprints/$id/edit',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthStockReconciliationIdEditRoute =
  AuthStockReconciliationIdEditRouteImport.update({
    id: '/stock-reconciliation/$id/edit',
    path: '/stock-reconciliation/$id/edit',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthStockEntriesIdEditRoute = AuthStockEntriesIdEditRouteImport.update({
  id: '/stock-entries/$id/edit',
  path: '/stock-entries/$id/edit',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSettlementsIdEditRoute = AuthSettlementsIdEditRouteImport.update({
  id: '/settlements/$id/edit',
  path: '/settlements/$id/edit',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSalesOrdersIdEditRoute = AuthSalesOrdersIdEditRouteImport.update({
  id: '/sales-orders/$id/edit',
  path: '/sales-orders/$id/edit',
  getParentRoute: () => AuthRoute,
} as any)
const AuthProjectsIdEditRoute = AuthProjectsIdEditRouteImport.update({
  id: '/projects/$id/edit',
  path: '/projects/$id/edit',
  getParentRoute: () => AuthRoute,
} as any)
const AuthPaymentsIdEditRoute = AuthPaymentsIdEditRouteImport.update({
  id: '/payments/$id/edit',
  path: '/payments/$id/edit',
  getParentRoute: () => AuthRoute,
} as any)
const AuthLandedCostIdEditRoute = AuthLandedCostIdEditRouteImport.update({
  id: '/landed-cost/$id/edit',
  path: '/landed-cost/$id/edit',
  getParentRoute: () => AuthRoute,
} as any)
const AuthInvoicesArNewRoute = AuthInvoicesArNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => AuthInvoicesArRoute,
} as any)
const AuthInvoicesApNewRoute = AuthInvoicesApNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => AuthInvoicesApRoute,
} as any)
const AuthInvoicesIdEditRoute = AuthInvoicesIdEditRouteImport.update({
  id: '/invoices/$id/edit',
  path: '/invoices/$id/edit',
  getParentRoute: () => AuthRoute,
} as any)
const AuthFinanceRegulatoryKpnRoute =
  AuthFinanceRegulatoryKpnRouteImport.update({
    id: '/finance/regulatory/kpn',
    path: '/finance/regulatory/kpn',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthFinanceRegulatoryEsfRoute =
  AuthFinanceRegulatoryEsfRouteImport.update({
    id: '/finance/regulatory/esf',
    path: '/finance/regulatory/esf',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthFinanceKpnIdRoute = AuthFinanceKpnIdRouteImport.update({
  id: '/finance/kpn/$id',
  path: '/finance/kpn/$id',
  getParentRoute: () => AuthRoute,
} as any)
const AuthFinanceEsfIdRoute = AuthFinanceEsfIdRouteImport.update({
  id: '/finance/esf/$id',
  path: '/finance/esf/$id',
  getParentRoute: () => AuthRoute,
} as any)
const AuthCounterpartiesIdEditRoute =
  AuthCounterpartiesIdEditRouteImport.update({
    id: '/counterparties/$id/edit',
    path: '/counterparties/$id/edit',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthBudgetsIdEditRoute = AuthBudgetsIdEditRouteImport.update({
  id: '/budgets/$id/edit',
  path: '/budgets/$id/edit',
  getParentRoute: () => AuthRoute,
} as any)
const AuthAdminIntegrationsPlatformRoute =
  AuthAdminIntegrationsPlatformRouteImport.update({
    id: '/integrations_/platform',
    path: '/integrations/platform',
    getParentRoute: () => AuthAdminRoute,
  } as any)
const AuthAdminHoldingsHoldingIdRoute =
  AuthAdminHoldingsHoldingIdRouteImport.update({
    id: '/holdings_/$holdingId',
    path: '/holdings/$holdingId',
    getParentRoute: () => AuthAdminRoute,
  } as any)
const AuthAdminEntitiesEntityIdRoute =
  AuthAdminEntitiesEntityIdRouteImport.update({
    id: '/entities_/$entityId',
    path: '/entities/$entityId',
    getParentRoute: () => AuthAdminRoute,
  } as any)
const AuthDocsRoleSlugIndexRoute = AuthDocsRoleSlugIndexRouteImport.update({
  id: '/docs/$role/$slug/',
  path: '/docs/$role/$slug/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthWorkTasksProjectIdTaskTaskIdRoute =
  AuthWorkTasksProjectIdTaskTaskIdRouteImport.update({
    id: '/work-tasks/$projectId_/task/$taskId',
    path: '/work-tasks/$projectId/task/$taskId',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthDocsRoleSlugHistoryRoute = AuthDocsRoleSlugHistoryRouteImport.update({
  id: '/docs/$role/$slug/history',
  path: '/docs/$role/$slug/history',
  getParentRoute: () => AuthRoute,
} as any)
const AuthDocsRoleSlugEditRoute = AuthDocsRoleSlugEditRouteImport.update({
  id: '/docs/$role/$slug/edit',
  path: '/docs/$role/$slug/edit',
  getParentRoute: () => AuthRoute,
} as any)
const AuthAdminUsersUserIdMembershipsRoute =
  AuthAdminUsersUserIdMembershipsRouteImport.update({
    id: '/users_/$userId/memberships',
    path: '/users/$userId/memberships',
    getParentRoute: () => AuthAdminRoute,
  } as any)
const AuthAdminIntegrationsConnectionsIdRoute =
  AuthAdminIntegrationsConnectionsIdRouteImport.update({
    id: '/integrations_/connections/$id',
    path: '/integrations/connections/$id',
    getParentRoute: () => AuthAdminRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AuthIndexRoute
  '/accept-invite': typeof AcceptInviteRoute
  '/confirm-email-change': typeof ConfirmEmailChangeRoute
  '/login': typeof LoginRoute
  '/reset-password': typeof ResetPasswordRoute
  '/admin': typeof AuthAdminRouteWithChildren
  '/anomalies': typeof AuthAnomaliesRoute
  '/approvals': typeof AuthApprovalsRoute
  '/batches': typeof AuthBatchesRoute
  '/chat': typeof AuthChatRoute
  '/conflicts': typeof AuthConflictsRoute
  '/cost': typeof AuthCostRoute
  '/design-system': typeof AuthDesignSystemRoute
  '/evidence': typeof AuthEvidenceRoute
  '/excel': typeof AuthExcelRoute
  '/force-password-change': typeof AuthForcePasswordChangeRoute
  '/my-day': typeof AuthMyDayRoute
  '/notifications': typeof AuthNotificationsRoute
  '/period-close': typeof AuthPeriodCloseRoute
  '/reconciliation': typeof AuthReconciliationRoute
  '/warehouses': typeof AuthWarehousesRoute
  '/work-blueprints': typeof AuthWorkBlueprintsRoute
  '/writeoff': typeof AuthWriteoffRoute
  '/auth/password-reset': typeof AuthPasswordResetRoute
  '/admin/approval-matrix': typeof AuthAdminApprovalMatrixRoute
  '/admin/audit': typeof AuthAdminAuditRoute
  '/admin/bank-import': typeof AuthAdminBankImportRoute
  '/admin/email-templates': typeof AuthAdminEmailTemplatesRoute
  '/admin/entities': typeof AuthAdminEntitiesRoute
  '/admin/fx-rates': typeof AuthAdminFxRatesRoute
  '/admin/holdings': typeof AuthAdminHoldingsRoute
  '/admin/integrations': typeof AuthAdminIntegrationsRoute
  '/admin/jobs': typeof AuthAdminJobsRoute
  '/admin/memory': typeof AuthAdminMemoryRoute
  '/admin/sync-staging': typeof AuthAdminSyncStagingRoute
  '/admin/task-automation': typeof AuthAdminTaskAutomationRoute
  '/admin/users': typeof AuthAdminUsersRoute
  '/admin/warehouse-access': typeof AuthAdminWarehouseAccessRoute
  '/boms/$bomId': typeof AuthBomsBomIdRoute
  '/boms/new': typeof AuthBomsNewRoute
  '/budgets/new': typeof AuthBudgetsNewRoute
  '/counterparties/new': typeof AuthCounterpartiesNewRoute
  '/docs/search': typeof AuthDocsSearchRoute
  '/finance/cash-flow': typeof AuthFinanceCashFlowRoute
  '/finance/cogs': typeof AuthFinanceCogsRoute
  '/finance/dashboard': typeof AuthFinanceDashboardRoute
  '/finance/onec-push': typeof AuthFinanceOnecPushRoute
  '/finance/pnl': typeof AuthFinancePnlRoute
  '/finance/snapshots': typeof AuthFinanceSnapshotsRoute
  '/finance/tax-summary': typeof AuthFinanceTaxSummaryRoute
  '/invoices/ap': typeof AuthInvoicesApRouteWithChildren
  '/invoices/ar': typeof AuthInvoicesArRouteWithChildren
  '/invoices/new': typeof AuthInvoicesNewRoute
  '/items/$itemId': typeof AuthItemsItemIdRoute
  '/landed-cost/new': typeof AuthLandedCostNewRoute
  '/me/preferences': typeof AuthMePreferencesRoute
  '/me/task-notifications': typeof AuthMeTaskNotificationsRoute
  '/onboarding/$step': typeof AuthOnboardingStepRoute
  '/payments/new': typeof AuthPaymentsNewRoute
  '/projects/new': typeof AuthProjectsNewRoute
  '/runs/$runId': typeof AuthRunsRunIdRoute
  '/sales-orders/new': typeof AuthSalesOrdersNewRoute
  '/settlements/new': typeof AuthSettlementsNewRoute
  '/stock-entries/new': typeof AuthStockEntriesNewRoute
  '/stock-reconciliation/new': typeof AuthStockReconciliationNewRoute
  '/stock/balance': typeof AuthStockBalanceRoute
  '/stock/ledger': typeof AuthStockLedgerRoute
  '/work-blueprints/$id': typeof AuthWorkBlueprintsIdRoute
  '/work-orders/new': typeof AuthWorkOrdersNewRoute
  '/work-tasks/$projectId': typeof AuthWorkTasksProjectIdRoute
  '/admin/': typeof AuthAdminIndexRoute
  '/boms/': typeof AuthBomsIndexRoute
  '/budgets/': typeof AuthBudgetsIndexRoute
  '/counterparties/': typeof AuthCounterpartiesIndexRoute
  '/docs/': typeof AuthDocsIndexRoute
  '/items/': typeof AuthItemsIndexRoute
  '/landed-cost/': typeof AuthLandedCostIndexRoute
  '/payments/': typeof AuthPaymentsIndexRoute
  '/projects/': typeof AuthProjectsIndexRoute
  '/runs/': typeof AuthRunsIndexRoute
  '/sales-orders/': typeof AuthSalesOrdersIndexRoute
  '/settlements/': typeof AuthSettlementsIndexRoute
  '/stock-entries/': typeof AuthStockEntriesIndexRoute
  '/stock-reconciliation/': typeof AuthStockReconciliationIndexRoute
  '/work-orders/': typeof AuthWorkOrdersIndexRoute
  '/work-tasks/': typeof AuthWorkTasksIndexRoute
  '/admin/entities/$entityId': typeof AuthAdminEntitiesEntityIdRoute
  '/admin/holdings/$holdingId': typeof AuthAdminHoldingsHoldingIdRoute
  '/admin/integrations/platform': typeof AuthAdminIntegrationsPlatformRoute
  '/budgets/$id/edit': typeof AuthBudgetsIdEditRoute
  '/counterparties/$id/edit': typeof AuthCounterpartiesIdEditRoute
  '/finance/esf/$id': typeof AuthFinanceEsfIdRoute
  '/finance/kpn/$id': typeof AuthFinanceKpnIdRoute
  '/finance/regulatory/esf': typeof AuthFinanceRegulatoryEsfRoute
  '/finance/regulatory/kpn': typeof AuthFinanceRegulatoryKpnRoute
  '/invoices/$id/edit': typeof AuthInvoicesIdEditRoute
  '/invoices/ap/new': typeof AuthInvoicesApNewRoute
  '/invoices/ar/new': typeof AuthInvoicesArNewRoute
  '/landed-cost/$id/edit': typeof AuthLandedCostIdEditRoute
  '/payments/$id/edit': typeof AuthPaymentsIdEditRoute
  '/projects/$id/edit': typeof AuthProjectsIdEditRoute
  '/sales-orders/$id/edit': typeof AuthSalesOrdersIdEditRoute
  '/settlements/$id/edit': typeof AuthSettlementsIdEditRoute
  '/stock-entries/$id/edit': typeof AuthStockEntriesIdEditRoute
  '/stock-reconciliation/$id/edit': typeof AuthStockReconciliationIdEditRoute
  '/work-blueprints/$id/edit': typeof AuthWorkBlueprintsIdEditRoute
  '/work-orders/$id/edit': typeof AuthWorkOrdersIdEditRoute
  '/work-tasks/task/$taskId': typeof AuthWorkTasksTaskTaskIdRoute
  '/budgets/$id/': typeof AuthBudgetsIdIndexRoute
  '/counterparties/$id/': typeof AuthCounterpartiesIdIndexRoute
  '/docs/$role/': typeof AuthDocsRoleIndexRoute
  '/finance/esf/': typeof AuthFinanceEsfIndexRoute
  '/finance/kpn/': typeof AuthFinanceKpnIndexRoute
  '/invoices/$id/': typeof AuthInvoicesIdIndexRoute
  '/landed-cost/$id/': typeof AuthLandedCostIdIndexRoute
  '/payments/$id/': typeof AuthPaymentsIdIndexRoute
  '/projects/$id/': typeof AuthProjectsIdIndexRoute
  '/sales-orders/$id/': typeof AuthSalesOrdersIdIndexRoute
  '/settlements/$id/': typeof AuthSettlementsIdIndexRoute
  '/stock-entries/$id/': typeof AuthStockEntriesIdIndexRoute
  '/stock-reconciliation/$id/': typeof AuthStockReconciliationIdIndexRoute
  '/work-orders/$id/': typeof AuthWorkOrdersIdIndexRoute
  '/admin/integrations/connections/$id': typeof AuthAdminIntegrationsConnectionsIdRoute
  '/admin/users/$userId/memberships': typeof AuthAdminUsersUserIdMembershipsRoute
  '/docs/$role/$slug/edit': typeof AuthDocsRoleSlugEditRoute
  '/docs/$role/$slug/history': typeof AuthDocsRoleSlugHistoryRoute
  '/work-tasks/$projectId/task/$taskId': typeof AuthWorkTasksProjectIdTaskTaskIdRoute
  '/docs/$role/$slug/': typeof AuthDocsRoleSlugIndexRoute
}
export interface FileRoutesByTo {
  '/accept-invite': typeof AcceptInviteRoute
  '/confirm-email-change': typeof ConfirmEmailChangeRoute
  '/login': typeof LoginRoute
  '/reset-password': typeof ResetPasswordRoute
  '/anomalies': typeof AuthAnomaliesRoute
  '/approvals': typeof AuthApprovalsRoute
  '/batches': typeof AuthBatchesRoute
  '/chat': typeof AuthChatRoute
  '/conflicts': typeof AuthConflictsRoute
  '/cost': typeof AuthCostRoute
  '/design-system': typeof AuthDesignSystemRoute
  '/evidence': typeof AuthEvidenceRoute
  '/excel': typeof AuthExcelRoute
  '/force-password-change': typeof AuthForcePasswordChangeRoute
  '/my-day': typeof AuthMyDayRoute
  '/notifications': typeof AuthNotificationsRoute
  '/period-close': typeof AuthPeriodCloseRoute
  '/reconciliation': typeof AuthReconciliationRoute
  '/warehouses': typeof AuthWarehousesRoute
  '/work-blueprints': typeof AuthWorkBlueprintsRoute
  '/writeoff': typeof AuthWriteoffRoute
  '/auth/password-reset': typeof AuthPasswordResetRoute
  '/': typeof AuthIndexRoute
  '/admin/approval-matrix': typeof AuthAdminApprovalMatrixRoute
  '/admin/audit': typeof AuthAdminAuditRoute
  '/admin/bank-import': typeof AuthAdminBankImportRoute
  '/admin/email-templates': typeof AuthAdminEmailTemplatesRoute
  '/admin/entities': typeof AuthAdminEntitiesRoute
  '/admin/fx-rates': typeof AuthAdminFxRatesRoute
  '/admin/holdings': typeof AuthAdminHoldingsRoute
  '/admin/integrations': typeof AuthAdminIntegrationsRoute
  '/admin/jobs': typeof AuthAdminJobsRoute
  '/admin/memory': typeof AuthAdminMemoryRoute
  '/admin/sync-staging': typeof AuthAdminSyncStagingRoute
  '/admin/task-automation': typeof AuthAdminTaskAutomationRoute
  '/admin/users': typeof AuthAdminUsersRoute
  '/admin/warehouse-access': typeof AuthAdminWarehouseAccessRoute
  '/boms/$bomId': typeof AuthBomsBomIdRoute
  '/boms/new': typeof AuthBomsNewRoute
  '/budgets/new': typeof AuthBudgetsNewRoute
  '/counterparties/new': typeof AuthCounterpartiesNewRoute
  '/docs/search': typeof AuthDocsSearchRoute
  '/finance/cash-flow': typeof AuthFinanceCashFlowRoute
  '/finance/cogs': typeof AuthFinanceCogsRoute
  '/finance/dashboard': typeof AuthFinanceDashboardRoute
  '/finance/onec-push': typeof AuthFinanceOnecPushRoute
  '/finance/pnl': typeof AuthFinancePnlRoute
  '/finance/snapshots': typeof AuthFinanceSnapshotsRoute
  '/finance/tax-summary': typeof AuthFinanceTaxSummaryRoute
  '/invoices/ap': typeof AuthInvoicesApRouteWithChildren
  '/invoices/ar': typeof AuthInvoicesArRouteWithChildren
  '/invoices/new': typeof AuthInvoicesNewRoute
  '/items/$itemId': typeof AuthItemsItemIdRoute
  '/landed-cost/new': typeof AuthLandedCostNewRoute
  '/me/preferences': typeof AuthMePreferencesRoute
  '/me/task-notifications': typeof AuthMeTaskNotificationsRoute
  '/onboarding/$step': typeof AuthOnboardingStepRoute
  '/payments/new': typeof AuthPaymentsNewRoute
  '/projects/new': typeof AuthProjectsNewRoute
  '/runs/$runId': typeof AuthRunsRunIdRoute
  '/sales-orders/new': typeof AuthSalesOrdersNewRoute
  '/settlements/new': typeof AuthSettlementsNewRoute
  '/stock-entries/new': typeof AuthStockEntriesNewRoute
  '/stock-reconciliation/new': typeof AuthStockReconciliationNewRoute
  '/stock/balance': typeof AuthStockBalanceRoute
  '/stock/ledger': typeof AuthStockLedgerRoute
  '/work-blueprints/$id': typeof AuthWorkBlueprintsIdRoute
  '/work-orders/new': typeof AuthWorkOrdersNewRoute
  '/work-tasks/$projectId': typeof AuthWorkTasksProjectIdRoute
  '/admin': typeof AuthAdminIndexRoute
  '/boms': typeof AuthBomsIndexRoute
  '/budgets': typeof AuthBudgetsIndexRoute
  '/counterparties': typeof AuthCounterpartiesIndexRoute
  '/docs': typeof AuthDocsIndexRoute
  '/items': typeof AuthItemsIndexRoute
  '/landed-cost': typeof AuthLandedCostIndexRoute
  '/payments': typeof AuthPaymentsIndexRoute
  '/projects': typeof AuthProjectsIndexRoute
  '/runs': typeof AuthRunsIndexRoute
  '/sales-orders': typeof AuthSalesOrdersIndexRoute
  '/settlements': typeof AuthSettlementsIndexRoute
  '/stock-entries': typeof AuthStockEntriesIndexRoute
  '/stock-reconciliation': typeof AuthStockReconciliationIndexRoute
  '/work-orders': typeof AuthWorkOrdersIndexRoute
  '/work-tasks': typeof AuthWorkTasksIndexRoute
  '/admin/entities/$entityId': typeof AuthAdminEntitiesEntityIdRoute
  '/admin/holdings/$holdingId': typeof AuthAdminHoldingsHoldingIdRoute
  '/admin/integrations/platform': typeof AuthAdminIntegrationsPlatformRoute
  '/budgets/$id/edit': typeof AuthBudgetsIdEditRoute
  '/counterparties/$id/edit': typeof AuthCounterpartiesIdEditRoute
  '/finance/esf/$id': typeof AuthFinanceEsfIdRoute
  '/finance/kpn/$id': typeof AuthFinanceKpnIdRoute
  '/finance/regulatory/esf': typeof AuthFinanceRegulatoryEsfRoute
  '/finance/regulatory/kpn': typeof AuthFinanceRegulatoryKpnRoute
  '/invoices/$id/edit': typeof AuthInvoicesIdEditRoute
  '/invoices/ap/new': typeof AuthInvoicesApNewRoute
  '/invoices/ar/new': typeof AuthInvoicesArNewRoute
  '/landed-cost/$id/edit': typeof AuthLandedCostIdEditRoute
  '/payments/$id/edit': typeof AuthPaymentsIdEditRoute
  '/projects/$id/edit': typeof AuthProjectsIdEditRoute
  '/sales-orders/$id/edit': typeof AuthSalesOrdersIdEditRoute
  '/settlements/$id/edit': typeof AuthSettlementsIdEditRoute
  '/stock-entries/$id/edit': typeof AuthStockEntriesIdEditRoute
  '/stock-reconciliation/$id/edit': typeof AuthStockReconciliationIdEditRoute
  '/work-blueprints/$id/edit': typeof AuthWorkBlueprintsIdEditRoute
  '/work-orders/$id/edit': typeof AuthWorkOrdersIdEditRoute
  '/work-tasks/task/$taskId': typeof AuthWorkTasksTaskTaskIdRoute
  '/budgets/$id': typeof AuthBudgetsIdIndexRoute
  '/counterparties/$id': typeof AuthCounterpartiesIdIndexRoute
  '/docs/$role': typeof AuthDocsRoleIndexRoute
  '/finance/esf': typeof AuthFinanceEsfIndexRoute
  '/finance/kpn': typeof AuthFinanceKpnIndexRoute
  '/invoices/$id': typeof AuthInvoicesIdIndexRoute
  '/landed-cost/$id': typeof AuthLandedCostIdIndexRoute
  '/payments/$id': typeof AuthPaymentsIdIndexRoute
  '/projects/$id': typeof AuthProjectsIdIndexRoute
  '/sales-orders/$id': typeof AuthSalesOrdersIdIndexRoute
  '/settlements/$id': typeof AuthSettlementsIdIndexRoute
  '/stock-entries/$id': typeof AuthStockEntriesIdIndexRoute
  '/stock-reconciliation/$id': typeof AuthStockReconciliationIdIndexRoute
  '/work-orders/$id': typeof AuthWorkOrdersIdIndexRoute
  '/admin/integrations/connections/$id': typeof AuthAdminIntegrationsConnectionsIdRoute
  '/admin/users/$userId/memberships': typeof AuthAdminUsersUserIdMembershipsRoute
  '/docs/$role/$slug/edit': typeof AuthDocsRoleSlugEditRoute
  '/docs/$role/$slug/history': typeof AuthDocsRoleSlugHistoryRoute
  '/work-tasks/$projectId/task/$taskId': typeof AuthWorkTasksProjectIdTaskTaskIdRoute
  '/docs/$role/$slug': typeof AuthDocsRoleSlugIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_auth': typeof AuthRouteWithChildren
  '/accept-invite': typeof AcceptInviteRoute
  '/confirm-email-change': typeof ConfirmEmailChangeRoute
  '/login': typeof LoginRoute
  '/reset-password': typeof ResetPasswordRoute
  '/_auth/admin': typeof AuthAdminRouteWithChildren
  '/_auth/anomalies': typeof AuthAnomaliesRoute
  '/_auth/approvals': typeof AuthApprovalsRoute
  '/_auth/batches': typeof AuthBatchesRoute
  '/_auth/chat': typeof AuthChatRoute
  '/_auth/conflicts': typeof AuthConflictsRoute
  '/_auth/cost': typeof AuthCostRoute
  '/_auth/design-system': typeof AuthDesignSystemRoute
  '/_auth/evidence': typeof AuthEvidenceRoute
  '/_auth/excel': typeof AuthExcelRoute
  '/_auth/force-password-change': typeof AuthForcePasswordChangeRoute
  '/_auth/my-day': typeof AuthMyDayRoute
  '/_auth/notifications': typeof AuthNotificationsRoute
  '/_auth/period-close': typeof AuthPeriodCloseRoute
  '/_auth/reconciliation': typeof AuthReconciliationRoute
  '/_auth/warehouses': typeof AuthWarehousesRoute
  '/_auth/work-blueprints': typeof AuthWorkBlueprintsRoute
  '/_auth/writeoff': typeof AuthWriteoffRoute
  '/auth/password-reset': typeof AuthPasswordResetRoute
  '/_auth/': typeof AuthIndexRoute
  '/_auth/admin/approval-matrix': typeof AuthAdminApprovalMatrixRoute
  '/_auth/admin/audit': typeof AuthAdminAuditRoute
  '/_auth/admin/bank-import': typeof AuthAdminBankImportRoute
  '/_auth/admin/email-templates': typeof AuthAdminEmailTemplatesRoute
  '/_auth/admin/entities': typeof AuthAdminEntitiesRoute
  '/_auth/admin/fx-rates': typeof AuthAdminFxRatesRoute
  '/_auth/admin/holdings': typeof AuthAdminHoldingsRoute
  '/_auth/admin/integrations': typeof AuthAdminIntegrationsRoute
  '/_auth/admin/jobs': typeof AuthAdminJobsRoute
  '/_auth/admin/memory': typeof AuthAdminMemoryRoute
  '/_auth/admin/sync-staging': typeof AuthAdminSyncStagingRoute
  '/_auth/admin/task-automation': typeof AuthAdminTaskAutomationRoute
  '/_auth/admin/users': typeof AuthAdminUsersRoute
  '/_auth/admin/warehouse-access': typeof AuthAdminWarehouseAccessRoute
  '/_auth/boms/$bomId': typeof AuthBomsBomIdRoute
  '/_auth/boms/new': typeof AuthBomsNewRoute
  '/_auth/budgets/new': typeof AuthBudgetsNewRoute
  '/_auth/counterparties/new': typeof AuthCounterpartiesNewRoute
  '/_auth/docs/search': typeof AuthDocsSearchRoute
  '/_auth/finance/cash-flow': typeof AuthFinanceCashFlowRoute
  '/_auth/finance/cogs': typeof AuthFinanceCogsRoute
  '/_auth/finance/dashboard': typeof AuthFinanceDashboardRoute
  '/_auth/finance/onec-push': typeof AuthFinanceOnecPushRoute
  '/_auth/finance/pnl': typeof AuthFinancePnlRoute
  '/_auth/finance/snapshots': typeof AuthFinanceSnapshotsRoute
  '/_auth/finance/tax-summary': typeof AuthFinanceTaxSummaryRoute
  '/_auth/invoices/ap': typeof AuthInvoicesApRouteWithChildren
  '/_auth/invoices/ar': typeof AuthInvoicesArRouteWithChildren
  '/_auth/invoices/new': typeof AuthInvoicesNewRoute
  '/_auth/items/$itemId': typeof AuthItemsItemIdRoute
  '/_auth/landed-cost/new': typeof AuthLandedCostNewRoute
  '/_auth/me/preferences': typeof AuthMePreferencesRoute
  '/_auth/me/task-notifications': typeof AuthMeTaskNotificationsRoute
  '/_auth/onboarding/$step': typeof AuthOnboardingStepRoute
  '/_auth/payments/new': typeof AuthPaymentsNewRoute
  '/_auth/projects/new': typeof AuthProjectsNewRoute
  '/_auth/runs/$runId': typeof AuthRunsRunIdRoute
  '/_auth/sales-orders/new': typeof AuthSalesOrdersNewRoute
  '/_auth/settlements/new': typeof AuthSettlementsNewRoute
  '/_auth/stock-entries/new': typeof AuthStockEntriesNewRoute
  '/_auth/stock-reconciliation/new': typeof AuthStockReconciliationNewRoute
  '/_auth/stock/balance': typeof AuthStockBalanceRoute
  '/_auth/stock/ledger': typeof AuthStockLedgerRoute
  '/_auth/work-blueprints_/$id': typeof AuthWorkBlueprintsIdRoute
  '/_auth/work-orders/new': typeof AuthWorkOrdersNewRoute
  '/_auth/work-tasks/$projectId': typeof AuthWorkTasksProjectIdRoute
  '/_auth/admin/': typeof AuthAdminIndexRoute
  '/_auth/boms/': typeof AuthBomsIndexRoute
  '/_auth/budgets/': typeof AuthBudgetsIndexRoute
  '/_auth/counterparties/': typeof AuthCounterpartiesIndexRoute
  '/_auth/docs/': typeof AuthDocsIndexRoute
  '/_auth/items/': typeof AuthItemsIndexRoute
  '/_auth/landed-cost/': typeof AuthLandedCostIndexRoute
  '/_auth/payments/': typeof AuthPaymentsIndexRoute
  '/_auth/projects/': typeof AuthProjectsIndexRoute
  '/_auth/runs/': typeof AuthRunsIndexRoute
  '/_auth/sales-orders/': typeof AuthSalesOrdersIndexRoute
  '/_auth/settlements/': typeof AuthSettlementsIndexRoute
  '/_auth/stock-entries/': typeof AuthStockEntriesIndexRoute
  '/_auth/stock-reconciliation/': typeof AuthStockReconciliationIndexRoute
  '/_auth/work-orders/': typeof AuthWorkOrdersIndexRoute
  '/_auth/work-tasks/': typeof AuthWorkTasksIndexRoute
  '/_auth/admin/entities_/$entityId': typeof AuthAdminEntitiesEntityIdRoute
  '/_auth/admin/holdings_/$holdingId': typeof AuthAdminHoldingsHoldingIdRoute
  '/_auth/admin/integrations_/platform': typeof AuthAdminIntegrationsPlatformRoute
  '/_auth/budgets/$id/edit': typeof AuthBudgetsIdEditRoute
  '/_auth/counterparties/$id/edit': typeof AuthCounterpartiesIdEditRoute
  '/_auth/finance/esf/$id': typeof AuthFinanceEsfIdRoute
  '/_auth/finance/kpn/$id': typeof AuthFinanceKpnIdRoute
  '/_auth/finance/regulatory/esf': typeof AuthFinanceRegulatoryEsfRoute
  '/_auth/finance/regulatory/kpn': typeof AuthFinanceRegulatoryKpnRoute
  '/_auth/invoices/$id/edit': typeof AuthInvoicesIdEditRoute
  '/_auth/invoices/ap/new': typeof AuthInvoicesApNewRoute
  '/_auth/invoices/ar/new': typeof AuthInvoicesArNewRoute
  '/_auth/landed-cost/$id/edit': typeof AuthLandedCostIdEditRoute
  '/_auth/payments/$id/edit': typeof AuthPaymentsIdEditRoute
  '/_auth/projects/$id/edit': typeof AuthProjectsIdEditRoute
  '/_auth/sales-orders/$id/edit': typeof AuthSalesOrdersIdEditRoute
  '/_auth/settlements/$id/edit': typeof AuthSettlementsIdEditRoute
  '/_auth/stock-entries/$id/edit': typeof AuthStockEntriesIdEditRoute
  '/_auth/stock-reconciliation/$id/edit': typeof AuthStockReconciliationIdEditRoute
  '/_auth/work-blueprints_/$id_/edit': typeof AuthWorkBlueprintsIdEditRoute
  '/_auth/work-orders/$id/edit': typeof AuthWorkOrdersIdEditRoute
  '/_auth/work-tasks/task/$taskId': typeof AuthWorkTasksTaskTaskIdRoute
  '/_auth/budgets/$id/': typeof AuthBudgetsIdIndexRoute
  '/_auth/counterparties/$id/': typeof AuthCounterpartiesIdIndexRoute
  '/_auth/docs/$role/': typeof AuthDocsRoleIndexRoute
  '/_auth/finance/esf/': typeof AuthFinanceEsfIndexRoute
  '/_auth/finance/kpn/': typeof AuthFinanceKpnIndexRoute
  '/_auth/invoices/$id/': typeof AuthInvoicesIdIndexRoute
  '/_auth/landed-cost/$id/': typeof AuthLandedCostIdIndexRoute
  '/_auth/payments/$id/': typeof AuthPaymentsIdIndexRoute
  '/_auth/projects/$id/': typeof AuthProjectsIdIndexRoute
  '/_auth/sales-orders/$id/': typeof AuthSalesOrdersIdIndexRoute
  '/_auth/settlements/$id/': typeof AuthSettlementsIdIndexRoute
  '/_auth/stock-entries/$id/': typeof AuthStockEntriesIdIndexRoute
  '/_auth/stock-reconciliation/$id/': typeof AuthStockReconciliationIdIndexRoute
  '/_auth/work-orders/$id/': typeof AuthWorkOrdersIdIndexRoute
  '/_auth/admin/integrations_/connections/$id': typeof AuthAdminIntegrationsConnectionsIdRoute
  '/_auth/admin/users_/$userId/memberships': typeof AuthAdminUsersUserIdMembershipsRoute
  '/_auth/docs/$role/$slug/edit': typeof AuthDocsRoleSlugEditRoute
  '/_auth/docs/$role/$slug/history': typeof AuthDocsRoleSlugHistoryRoute
  '/_auth/work-tasks/$projectId_/task/$taskId': typeof AuthWorkTasksProjectIdTaskTaskIdRoute
  '/_auth/docs/$role/$slug/': typeof AuthDocsRoleSlugIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/accept-invite'
    | '/confirm-email-change'
    | '/login'
    | '/reset-password'
    | '/admin'
    | '/anomalies'
    | '/approvals'
    | '/batches'
    | '/chat'
    | '/conflicts'
    | '/cost'
    | '/design-system'
    | '/evidence'
    | '/excel'
    | '/force-password-change'
    | '/my-day'
    | '/notifications'
    | '/period-close'
    | '/reconciliation'
    | '/warehouses'
    | '/work-blueprints'
    | '/writeoff'
    | '/auth/password-reset'
    | '/admin/approval-matrix'
    | '/admin/audit'
    | '/admin/bank-import'
    | '/admin/email-templates'
    | '/admin/entities'
    | '/admin/fx-rates'
    | '/admin/holdings'
    | '/admin/integrations'
    | '/admin/jobs'
    | '/admin/memory'
    | '/admin/sync-staging'
    | '/admin/task-automation'
    | '/admin/users'
    | '/admin/warehouse-access'
    | '/boms/$bomId'
    | '/boms/new'
    | '/budgets/new'
    | '/counterparties/new'
    | '/docs/search'
    | '/finance/cash-flow'
    | '/finance/cogs'
    | '/finance/dashboard'
    | '/finance/onec-push'
    | '/finance/pnl'
    | '/finance/snapshots'
    | '/finance/tax-summary'
    | '/invoices/ap'
    | '/invoices/ar'
    | '/invoices/new'
    | '/items/$itemId'
    | '/landed-cost/new'
    | '/me/preferences'
    | '/me/task-notifications'
    | '/onboarding/$step'
    | '/payments/new'
    | '/projects/new'
    | '/runs/$runId'
    | '/sales-orders/new'
    | '/settlements/new'
    | '/stock-entries/new'
    | '/stock-reconciliation/new'
    | '/stock/balance'
    | '/stock/ledger'
    | '/work-blueprints/$id'
    | '/work-orders/new'
    | '/work-tasks/$projectId'
    | '/admin/'
    | '/boms/'
    | '/budgets/'
    | '/counterparties/'
    | '/docs/'
    | '/items/'
    | '/landed-cost/'
    | '/payments/'
    | '/projects/'
    | '/runs/'
    | '/sales-orders/'
    | '/settlements/'
    | '/stock-entries/'
    | '/stock-reconciliation/'
    | '/work-orders/'
    | '/work-tasks/'
    | '/admin/entities/$entityId'
    | '/admin/holdings/$holdingId'
    | '/admin/integrations/platform'
    | '/budgets/$id/edit'
    | '/counterparties/$id/edit'
    | '/finance/esf/$id'
    | '/finance/kpn/$id'
    | '/finance/regulatory/esf'
    | '/finance/regulatory/kpn'
    | '/invoices/$id/edit'
    | '/invoices/ap/new'
    | '/invoices/ar/new'
    | '/landed-cost/$id/edit'
    | '/payments/$id/edit'
    | '/projects/$id/edit'
    | '/sales-orders/$id/edit'
    | '/settlements/$id/edit'
    | '/stock-entries/$id/edit'
    | '/stock-reconciliation/$id/edit'
    | '/work-blueprints/$id/edit'
    | '/work-orders/$id/edit'
    | '/work-tasks/task/$taskId'
    | '/budgets/$id/'
    | '/counterparties/$id/'
    | '/docs/$role/'
    | '/finance/esf/'
    | '/finance/kpn/'
    | '/invoices/$id/'
    | '/landed-cost/$id/'
    | '/payments/$id/'
    | '/projects/$id/'
    | '/sales-orders/$id/'
    | '/settlements/$id/'
    | '/stock-entries/$id/'
    | '/stock-reconciliation/$id/'
    | '/work-orders/$id/'
    | '/admin/integrations/connections/$id'
    | '/admin/users/$userId/memberships'
    | '/docs/$role/$slug/edit'
    | '/docs/$role/$slug/history'
    | '/work-tasks/$projectId/task/$taskId'
    | '/docs/$role/$slug/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/accept-invite'
    | '/confirm-email-change'
    | '/login'
    | '/reset-password'
    | '/anomalies'
    | '/approvals'
    | '/batches'
    | '/chat'
    | '/conflicts'
    | '/cost'
    | '/design-system'
    | '/evidence'
    | '/excel'
    | '/force-password-change'
    | '/my-day'
    | '/notifications'
    | '/period-close'
    | '/reconciliation'
    | '/warehouses'
    | '/work-blueprints'
    | '/writeoff'
    | '/auth/password-reset'
    | '/'
    | '/admin/approval-matrix'
    | '/admin/audit'
    | '/admin/bank-import'
    | '/admin/email-templates'
    | '/admin/entities'
    | '/admin/fx-rates'
    | '/admin/holdings'
    | '/admin/integrations'
    | '/admin/jobs'
    | '/admin/memory'
    | '/admin/sync-staging'
    | '/admin/task-automation'
    | '/admin/users'
    | '/admin/warehouse-access'
    | '/boms/$bomId'
    | '/boms/new'
    | '/budgets/new'
    | '/counterparties/new'
    | '/docs/search'
    | '/finance/cash-flow'
    | '/finance/cogs'
    | '/finance/dashboard'
    | '/finance/onec-push'
    | '/finance/pnl'
    | '/finance/snapshots'
    | '/finance/tax-summary'
    | '/invoices/ap'
    | '/invoices/ar'
    | '/invoices/new'
    | '/items/$itemId'
    | '/landed-cost/new'
    | '/me/preferences'
    | '/me/task-notifications'
    | '/onboarding/$step'
    | '/payments/new'
    | '/projects/new'
    | '/runs/$runId'
    | '/sales-orders/new'
    | '/settlements/new'
    | '/stock-entries/new'
    | '/stock-reconciliation/new'
    | '/stock/balance'
    | '/stock/ledger'
    | '/work-blueprints/$id'
    | '/work-orders/new'
    | '/work-tasks/$projectId'
    | '/admin'
    | '/boms'
    | '/budgets'
    | '/counterparties'
    | '/docs'
    | '/items'
    | '/landed-cost'
    | '/payments'
    | '/projects'
    | '/runs'
    | '/sales-orders'
    | '/settlements'
    | '/stock-entries'
    | '/stock-reconciliation'
    | '/work-orders'
    | '/work-tasks'
    | '/admin/entities/$entityId'
    | '/admin/holdings/$holdingId'
    | '/admin/integrations/platform'
    | '/budgets/$id/edit'
    | '/counterparties/$id/edit'
    | '/finance/esf/$id'
    | '/finance/kpn/$id'
    | '/finance/regulatory/esf'
    | '/finance/regulatory/kpn'
    | '/invoices/$id/edit'
    | '/invoices/ap/new'
    | '/invoices/ar/new'
    | '/landed-cost/$id/edit'
    | '/payments/$id/edit'
    | '/projects/$id/edit'
    | '/sales-orders/$id/edit'
    | '/settlements/$id/edit'
    | '/stock-entries/$id/edit'
    | '/stock-reconciliation/$id/edit'
    | '/work-blueprints/$id/edit'
    | '/work-orders/$id/edit'
    | '/work-tasks/task/$taskId'
    | '/budgets/$id'
    | '/counterparties/$id'
    | '/docs/$role'
    | '/finance/esf'
    | '/finance/kpn'
    | '/invoices/$id'
    | '/landed-cost/$id'
    | '/payments/$id'
    | '/projects/$id'
    | '/sales-orders/$id'
    | '/settlements/$id'
    | '/stock-entries/$id'
    | '/stock-reconciliation/$id'
    | '/work-orders/$id'
    | '/admin/integrations/connections/$id'
    | '/admin/users/$userId/memberships'
    | '/docs/$role/$slug/edit'
    | '/docs/$role/$slug/history'
    | '/work-tasks/$projectId/task/$taskId'
    | '/docs/$role/$slug'
  id:
    | '__root__'
    | '/_auth'
    | '/accept-invite'
    | '/confirm-email-change'
    | '/login'
    | '/reset-password'
    | '/_auth/admin'
    | '/_auth/anomalies'
    | '/_auth/approvals'
    | '/_auth/batches'
    | '/_auth/chat'
    | '/_auth/conflicts'
    | '/_auth/cost'
    | '/_auth/design-system'
    | '/_auth/evidence'
    | '/_auth/excel'
    | '/_auth/force-password-change'
    | '/_auth/my-day'
    | '/_auth/notifications'
    | '/_auth/period-close'
    | '/_auth/reconciliation'
    | '/_auth/warehouses'
    | '/_auth/work-blueprints'
    | '/_auth/writeoff'
    | '/auth/password-reset'
    | '/_auth/'
    | '/_auth/admin/approval-matrix'
    | '/_auth/admin/audit'
    | '/_auth/admin/bank-import'
    | '/_auth/admin/email-templates'
    | '/_auth/admin/entities'
    | '/_auth/admin/fx-rates'
    | '/_auth/admin/holdings'
    | '/_auth/admin/integrations'
    | '/_auth/admin/jobs'
    | '/_auth/admin/memory'
    | '/_auth/admin/sync-staging'
    | '/_auth/admin/task-automation'
    | '/_auth/admin/users'
    | '/_auth/admin/warehouse-access'
    | '/_auth/boms/$bomId'
    | '/_auth/boms/new'
    | '/_auth/budgets/new'
    | '/_auth/counterparties/new'
    | '/_auth/docs/search'
    | '/_auth/finance/cash-flow'
    | '/_auth/finance/cogs'
    | '/_auth/finance/dashboard'
    | '/_auth/finance/onec-push'
    | '/_auth/finance/pnl'
    | '/_auth/finance/snapshots'
    | '/_auth/finance/tax-summary'
    | '/_auth/invoices/ap'
    | '/_auth/invoices/ar'
    | '/_auth/invoices/new'
    | '/_auth/items/$itemId'
    | '/_auth/landed-cost/new'
    | '/_auth/me/preferences'
    | '/_auth/me/task-notifications'
    | '/_auth/onboarding/$step'
    | '/_auth/payments/new'
    | '/_auth/projects/new'
    | '/_auth/runs/$runId'
    | '/_auth/sales-orders/new'
    | '/_auth/settlements/new'
    | '/_auth/stock-entries/new'
    | '/_auth/stock-reconciliation/new'
    | '/_auth/stock/balance'
    | '/_auth/stock/ledger'
    | '/_auth/work-blueprints_/$id'
    | '/_auth/work-orders/new'
    | '/_auth/work-tasks/$projectId'
    | '/_auth/admin/'
    | '/_auth/boms/'
    | '/_auth/budgets/'
    | '/_auth/counterparties/'
    | '/_auth/docs/'
    | '/_auth/items/'
    | '/_auth/landed-cost/'
    | '/_auth/payments/'
    | '/_auth/projects/'
    | '/_auth/runs/'
    | '/_auth/sales-orders/'
    | '/_auth/settlements/'
    | '/_auth/stock-entries/'
    | '/_auth/stock-reconciliation/'
    | '/_auth/work-orders/'
    | '/_auth/work-tasks/'
    | '/_auth/admin/entities_/$entityId'
    | '/_auth/admin/holdings_/$holdingId'
    | '/_auth/admin/integrations_/platform'
    | '/_auth/budgets/$id/edit'
    | '/_auth/counterparties/$id/edit'
    | '/_auth/finance/esf/$id'
    | '/_auth/finance/kpn/$id'
    | '/_auth/finance/regulatory/esf'
    | '/_auth/finance/regulatory/kpn'
    | '/_auth/invoices/$id/edit'
    | '/_auth/invoices/ap/new'
    | '/_auth/invoices/ar/new'
    | '/_auth/landed-cost/$id/edit'
    | '/_auth/payments/$id/edit'
    | '/_auth/projects/$id/edit'
    | '/_auth/sales-orders/$id/edit'
    | '/_auth/settlements/$id/edit'
    | '/_auth/stock-entries/$id/edit'
    | '/_auth/stock-reconciliation/$id/edit'
    | '/_auth/work-blueprints_/$id_/edit'
    | '/_auth/work-orders/$id/edit'
    | '/_auth/work-tasks/task/$taskId'
    | '/_auth/budgets/$id/'
    | '/_auth/counterparties/$id/'
    | '/_auth/docs/$role/'
    | '/_auth/finance/esf/'
    | '/_auth/finance/kpn/'
    | '/_auth/invoices/$id/'
    | '/_auth/landed-cost/$id/'
    | '/_auth/payments/$id/'
    | '/_auth/projects/$id/'
    | '/_auth/sales-orders/$id/'
    | '/_auth/settlements/$id/'
    | '/_auth/stock-entries/$id/'
    | '/_auth/stock-reconciliation/$id/'
    | '/_auth/work-orders/$id/'
    | '/_auth/admin/integrations_/connections/$id'
    | '/_auth/admin/users_/$userId/memberships'
    | '/_auth/docs/$role/$slug/edit'
    | '/_auth/docs/$role/$slug/history'
    | '/_auth/work-tasks/$projectId_/task/$taskId'
    | '/_auth/docs/$role/$slug/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthRoute: typeof AuthRouteWithChildren
  AcceptInviteRoute: typeof AcceptInviteRoute
  ConfirmEmailChangeRoute: typeof ConfirmEmailChangeRoute
  LoginRoute: typeof LoginRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  AuthPasswordResetRoute: typeof AuthPasswordResetRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/confirm-email-change': {
      id: '/confirm-email-change'
      path: '/confirm-email-change'
      fullPath: '/confirm-email-change'
      preLoaderRoute: typeof ConfirmEmailChangeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/accept-invite': {
      id: '/accept-invite'
      path: '/accept-invite'
      fullPath: '/accept-invite'
      preLoaderRoute: typeof AcceptInviteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/': {
      id: '/_auth/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/auth/password-reset': {
      id: '/auth/password-reset'
      path: '/auth/password-reset'
      fullPath: '/auth/password-reset'
      preLoaderRoute: typeof AuthPasswordResetRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/writeoff': {
      id: '/_auth/writeoff'
      path: '/writeoff'
      fullPath: '/writeoff'
      preLoaderRoute: typeof AuthWriteoffRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/work-blueprints': {
      id: '/_auth/work-blueprints'
      path: '/work-blueprints'
      fullPath: '/work-blueprints'
      preLoaderRoute: typeof AuthWorkBlueprintsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/warehouses': {
      id: '/_auth/warehouses'
      path: '/warehouses'
      fullPath: '/warehouses'
      preLoaderRoute: typeof AuthWarehousesRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/reconciliation': {
      id: '/_auth/reconciliation'
      path: '/reconciliation'
      fullPath: '/reconciliation'
      preLoaderRoute: typeof AuthReconciliationRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/period-close': {
      id: '/_auth/period-close'
      path: '/period-close'
      fullPath: '/period-close'
      preLoaderRoute: typeof AuthPeriodCloseRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/notifications': {
      id: '/_auth/notifications'
      path: '/notifications'
      fullPath: '/notifications'
      preLoaderRoute: typeof AuthNotificationsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/my-day': {
      id: '/_auth/my-day'
      path: '/my-day'
      fullPath: '/my-day'
      preLoaderRoute: typeof AuthMyDayRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/force-password-change': {
      id: '/_auth/force-password-change'
      path: '/force-password-change'
      fullPath: '/force-password-change'
      preLoaderRoute: typeof AuthForcePasswordChangeRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/excel': {
      id: '/_auth/excel'
      path: '/excel'
      fullPath: '/excel'
      preLoaderRoute: typeof AuthExcelRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/evidence': {
      id: '/_auth/evidence'
      path: '/evidence'
      fullPath: '/evidence'
      preLoaderRoute: typeof AuthEvidenceRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/design-system': {
      id: '/_auth/design-system'
      path: '/design-system'
      fullPath: '/design-system'
      preLoaderRoute: typeof AuthDesignSystemRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/cost': {
      id: '/_auth/cost'
      path: '/cost'
      fullPath: '/cost'
      preLoaderRoute: typeof AuthCostRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/conflicts': {
      id: '/_auth/conflicts'
      path: '/conflicts'
      fullPath: '/conflicts'
      preLoaderRoute: typeof AuthConflictsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/chat': {
      id: '/_auth/chat'
      path: '/chat'
      fullPath: '/chat'
      preLoaderRoute: typeof AuthChatRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/batches': {
      id: '/_auth/batches'
      path: '/batches'
      fullPath: '/batches'
      preLoaderRoute: typeof AuthBatchesRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/approvals': {
      id: '/_auth/approvals'
      path: '/approvals'
      fullPath: '/approvals'
      preLoaderRoute: typeof AuthApprovalsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/anomalies': {
      id: '/_auth/anomalies'
      path: '/anomalies'
      fullPath: '/anomalies'
      preLoaderRoute: typeof AuthAnomaliesRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/admin': {
      id: '/_auth/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AuthAdminRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/work-tasks/': {
      id: '/_auth/work-tasks/'
      path: '/work-tasks'
      fullPath: '/work-tasks/'
      preLoaderRoute: typeof AuthWorkTasksIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/work-orders/': {
      id: '/_auth/work-orders/'
      path: '/work-orders'
      fullPath: '/work-orders/'
      preLoaderRoute: typeof AuthWorkOrdersIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/stock-reconciliation/': {
      id: '/_auth/stock-reconciliation/'
      path: '/stock-reconciliation'
      fullPath: '/stock-reconciliation/'
      preLoaderRoute: typeof AuthStockReconciliationIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/stock-entries/': {
      id: '/_auth/stock-entries/'
      path: '/stock-entries'
      fullPath: '/stock-entries/'
      preLoaderRoute: typeof AuthStockEntriesIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/settlements/': {
      id: '/_auth/settlements/'
      path: '/settlements'
      fullPath: '/settlements/'
      preLoaderRoute: typeof AuthSettlementsIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/sales-orders/': {
      id: '/_auth/sales-orders/'
      path: '/sales-orders'
      fullPath: '/sales-orders/'
      preLoaderRoute: typeof AuthSalesOrdersIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/runs/': {
      id: '/_auth/runs/'
      path: '/runs'
      fullPath: '/runs/'
      preLoaderRoute: typeof AuthRunsIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/projects/': {
      id: '/_auth/projects/'
      path: '/projects'
      fullPath: '/projects/'
      preLoaderRoute: typeof AuthProjectsIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/payments/': {
      id: '/_auth/payments/'
      path: '/payments'
      fullPath: '/payments/'
      preLoaderRoute: typeof AuthPaymentsIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/landed-cost/': {
      id: '/_auth/landed-cost/'
      path: '/landed-cost'
      fullPath: '/landed-cost/'
      preLoaderRoute: typeof AuthLandedCostIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/items/': {
      id: '/_auth/items/'
      path: '/items'
      fullPath: '/items/'
      preLoaderRoute: typeof AuthItemsIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/docs/': {
      id: '/_auth/docs/'
      path: '/docs'
      fullPath: '/docs/'
      preLoaderRoute: typeof AuthDocsIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/counterparties/': {
      id: '/_auth/counterparties/'
      path: '/counterparties'
      fullPath: '/counterparties/'
      preLoaderRoute: typeof AuthCounterpartiesIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/budgets/': {
      id: '/_auth/budgets/'
      path: '/budgets'
      fullPath: '/budgets/'
      preLoaderRoute: typeof AuthBudgetsIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/boms/': {
      id: '/_auth/boms/'
      path: '/boms'
      fullPath: '/boms/'
      preLoaderRoute: typeof AuthBomsIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/admin/': {
      id: '/_auth/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AuthAdminIndexRouteImport
      parentRoute: typeof AuthAdminRoute
    }
    '/_auth/work-tasks/$projectId': {
      id: '/_auth/work-tasks/$projectId'
      path: '/work-tasks/$projectId'
      fullPath: '/work-tasks/$projectId'
      preLoaderRoute: typeof AuthWorkTasksProjectIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/work-orders/new': {
      id: '/_auth/work-orders/new'
      path: '/work-orders/new'
      fullPath: '/work-orders/new'
      preLoaderRoute: typeof AuthWorkOrdersNewRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/work-blueprints_/$id': {
      id: '/_auth/work-blueprints_/$id'
      path: '/work-blueprints/$id'
      fullPath: '/work-blueprints/$id'
      preLoaderRoute: typeof AuthWorkBlueprintsIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/stock/ledger': {
      id: '/_auth/stock/ledger'
      path: '/stock/ledger'
      fullPath: '/stock/ledger'
      preLoaderRoute: typeof AuthStockLedgerRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/stock/balance': {
      id: '/_auth/stock/balance'
      path: '/stock/balance'
      fullPath: '/stock/balance'
      preLoaderRoute: typeof AuthStockBalanceRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/stock-reconciliation/new': {
      id: '/_auth/stock-reconciliation/new'
      path: '/stock-reconciliation/new'
      fullPath: '/stock-reconciliation/new'
      preLoaderRoute: typeof AuthStockReconciliationNewRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/stock-entries/new': {
      id: '/_auth/stock-entries/new'
      path: '/stock-entries/new'
      fullPath: '/stock-entries/new'
      preLoaderRoute: typeof AuthStockEntriesNewRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/settlements/new': {
      id: '/_auth/settlements/new'
      path: '/settlements/new'
      fullPath: '/settlements/new'
      preLoaderRoute: typeof AuthSettlementsNewRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/sales-orders/new': {
      id: '/_auth/sales-orders/new'
      path: '/sales-orders/new'
      fullPath: '/sales-orders/new'
      preLoaderRoute: typeof AuthSalesOrdersNewRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/runs/$runId': {
      id: '/_auth/runs/$runId'
      path: '/runs/$runId'
      fullPath: '/runs/$runId'
      preLoaderRoute: typeof AuthRunsRunIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/projects/new': {
      id: '/_auth/projects/new'
      path: '/projects/new'
      fullPath: '/projects/new'
      preLoaderRoute: typeof AuthProjectsNewRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/payments/new': {
      id: '/_auth/payments/new'
      path: '/payments/new'
      fullPath: '/payments/new'
      preLoaderRoute: typeof AuthPaymentsNewRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/onboarding/$step': {
      id: '/_auth/onboarding/$step'
      path: '/onboarding/$step'
      fullPath: '/onboarding/$step'
      preLoaderRoute: typeof AuthOnboardingStepRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/me/task-notifications': {
      id: '/_auth/me/task-notifications'
      path: '/me/task-notifications'
      fullPath: '/me/task-notifications'
      preLoaderRoute: typeof AuthMeTaskNotificationsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/me/preferences': {
      id: '/_auth/me/preferences'
      path: '/me/preferences'
      fullPath: '/me/preferences'
      preLoaderRoute: typeof AuthMePreferencesRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/landed-cost/new': {
      id: '/_auth/landed-cost/new'
      path: '/landed-cost/new'
      fullPath: '/landed-cost/new'
      preLoaderRoute: typeof AuthLandedCostNewRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/items/$itemId': {
      id: '/_auth/items/$itemId'
      path: '/items/$itemId'
      fullPath: '/items/$itemId'
      preLoaderRoute: typeof AuthItemsItemIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/invoices/new': {
      id: '/_auth/invoices/new'
      path: '/invoices/new'
      fullPath: '/invoices/new'
      preLoaderRoute: typeof AuthInvoicesNewRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/invoices/ar': {
      id: '/_auth/invoices/ar'
      path: '/invoices/ar'
      fullPath: '/invoices/ar'
      preLoaderRoute: typeof AuthInvoicesArRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/invoices/ap': {
      id: '/_auth/invoices/ap'
      path: '/invoices/ap'
      fullPath: '/invoices/ap'
      preLoaderRoute: typeof AuthInvoicesApRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/finance/tax-summary': {
      id: '/_auth/finance/tax-summary'
      path: '/finance/tax-summary'
      fullPath: '/finance/tax-summary'
      preLoaderRoute: typeof AuthFinanceTaxSummaryRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/finance/snapshots': {
      id: '/_auth/finance/snapshots'
      path: '/finance/snapshots'
      fullPath: '/finance/snapshots'
      preLoaderRoute: typeof AuthFinanceSnapshotsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/finance/pnl': {
      id: '/_auth/finance/pnl'
      path: '/finance/pnl'
      fullPath: '/finance/pnl'
      preLoaderRoute: typeof AuthFinancePnlRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/finance/onec-push': {
      id: '/_auth/finance/onec-push'
      path: '/finance/onec-push'
      fullPath: '/finance/onec-push'
      preLoaderRoute: typeof AuthFinanceOnecPushRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/finance/dashboard': {
      id: '/_auth/finance/dashboard'
      path: '/finance/dashboard'
      fullPath: '/finance/dashboard'
      preLoaderRoute: typeof AuthFinanceDashboardRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/finance/cogs': {
      id: '/_auth/finance/cogs'
      path: '/finance/cogs'
      fullPath: '/finance/cogs'
      preLoaderRoute: typeof AuthFinanceCogsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/finance/cash-flow': {
      id: '/_auth/finance/cash-flow'
      path: '/finance/cash-flow'
      fullPath: '/finance/cash-flow'
      preLoaderRoute: typeof AuthFinanceCashFlowRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/docs/search': {
      id: '/_auth/docs/search'
      path: '/docs/search'
      fullPath: '/docs/search'
      preLoaderRoute: typeof AuthDocsSearchRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/counterparties/new': {
      id: '/_auth/counterparties/new'
      path: '/counterparties/new'
      fullPath: '/counterparties/new'
      preLoaderRoute: typeof AuthCounterpartiesNewRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/budgets/new': {
      id: '/_auth/budgets/new'
      path: '/budgets/new'
      fullPath: '/budgets/new'
      preLoaderRoute: typeof AuthBudgetsNewRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/boms/new': {
      id: '/_auth/boms/new'
      path: '/boms/new'
      fullPath: '/boms/new'
      preLoaderRoute: typeof AuthBomsNewRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/boms/$bomId': {
      id: '/_auth/boms/$bomId'
      path: '/boms/$bomId'
      fullPath: '/boms/$bomId'
      preLoaderRoute: typeof AuthBomsBomIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/admin/warehouse-access': {
      id: '/_auth/admin/warehouse-access'
      path: '/warehouse-access'
      fullPath: '/admin/warehouse-access'
      preLoaderRoute: typeof AuthAdminWarehouseAccessRouteImport
      parentRoute: typeof AuthAdminRoute
    }
    '/_auth/admin/users': {
      id: '/_auth/admin/users'
      path: '/users'
      fullPath: '/admin/users'
      preLoaderRoute: typeof AuthAdminUsersRouteImport
      parentRoute: typeof AuthAdminRoute
    }
    '/_auth/admin/task-automation': {
      id: '/_auth/admin/task-automation'
      path: '/task-automation'
      fullPath: '/admin/task-automation'
      preLoaderRoute: typeof AuthAdminTaskAutomationRouteImport
      parentRoute: typeof AuthAdminRoute
    }
    '/_auth/admin/sync-staging': {
      id: '/_auth/admin/sync-staging'
      path: '/sync-staging'
      fullPath: '/admin/sync-staging'
      preLoaderRoute: typeof AuthAdminSyncStagingRouteImport
      parentRoute: typeof AuthAdminRoute
    }
    '/_auth/admin/memory': {
      id: '/_auth/admin/memory'
      path: '/memory'
      fullPath: '/admin/memory'
      preLoaderRoute: typeof AuthAdminMemoryRouteImport
      parentRoute: typeof AuthAdminRoute
    }
    '/_auth/admin/jobs': {
      id: '/_auth/admin/jobs'
      path: '/jobs'
      fullPath: '/admin/jobs'
      preLoaderRoute: typeof AuthAdminJobsRouteImport
      parentRoute: typeof AuthAdminRoute
    }
    '/_auth/admin/integrations': {
      id: '/_auth/admin/integrations'
      path: '/integrations'
      fullPath: '/admin/integrations'
      preLoaderRoute: typeof AuthAdminIntegrationsRouteImport
      parentRoute: typeof AuthAdminRoute
    }
    '/_auth/admin/holdings': {
      id: '/_auth/admin/holdings'
      path: '/holdings'
      fullPath: '/admin/holdings'
      preLoaderRoute: typeof AuthAdminHoldingsRouteImport
      parentRoute: typeof AuthAdminRoute
    }
    '/_auth/admin/fx-rates': {
      id: '/_auth/admin/fx-rates'
      path: '/fx-rates'
      fullPath: '/admin/fx-rates'
      preLoaderRoute: typeof AuthAdminFxRatesRouteImport
      parentRoute: typeof AuthAdminRoute
    }
    '/_auth/admin/entities': {
      id: '/_auth/admin/entities'
      path: '/entities'
      fullPath: '/admin/entities'
      preLoaderRoute: typeof AuthAdminEntitiesRouteImport
      parentRoute: typeof AuthAdminRoute
    }
    '/_auth/admin/email-templates': {
      id: '/_auth/admin/email-templates'
      path: '/email-templates'
      fullPath: '/admin/email-templates'
      preLoaderRoute: typeof AuthAdminEmailTemplatesRouteImport
      parentRoute: typeof AuthAdminRoute
    }
    '/_auth/admin/bank-import': {
      id: '/_auth/admin/bank-import'
      path: '/bank-import'
      fullPath: '/admin/bank-import'
      preLoaderRoute: typeof AuthAdminBankImportRouteImport
      parentRoute: typeof AuthAdminRoute
    }
    '/_auth/admin/audit': {
      id: '/_auth/admin/audit'
      path: '/audit'
      fullPath: '/admin/audit'
      preLoaderRoute: typeof AuthAdminAuditRouteImport
      parentRoute: typeof AuthAdminRoute
    }
    '/_auth/admin/approval-matrix': {
      id: '/_auth/admin/approval-matrix'
      path: '/approval-matrix'
      fullPath: '/admin/approval-matrix'
      preLoaderRoute: typeof AuthAdminApprovalMatrixRouteImport
      parentRoute: typeof AuthAdminRoute
    }
    '/_auth/work-orders/$id/': {
      id: '/_auth/work-orders/$id/'
      path: '/work-orders/$id'
      fullPath: '/work-orders/$id/'
      preLoaderRoute: typeof AuthWorkOrdersIdIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/stock-reconciliation/$id/': {
      id: '/_auth/stock-reconciliation/$id/'
      path: '/stock-reconciliation/$id'
      fullPath: '/stock-reconciliation/$id/'
      preLoaderRoute: typeof AuthStockReconciliationIdIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/stock-entries/$id/': {
      id: '/_auth/stock-entries/$id/'
      path: '/stock-entries/$id'
      fullPath: '/stock-entries/$id/'
      preLoaderRoute: typeof AuthStockEntriesIdIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/settlements/$id/': {
      id: '/_auth/settlements/$id/'
      path: '/settlements/$id'
      fullPath: '/settlements/$id/'
      preLoaderRoute: typeof AuthSettlementsIdIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/sales-orders/$id/': {
      id: '/_auth/sales-orders/$id/'
      path: '/sales-orders/$id'
      fullPath: '/sales-orders/$id/'
      preLoaderRoute: typeof AuthSalesOrdersIdIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/projects/$id/': {
      id: '/_auth/projects/$id/'
      path: '/projects/$id'
      fullPath: '/projects/$id/'
      preLoaderRoute: typeof AuthProjectsIdIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/payments/$id/': {
      id: '/_auth/payments/$id/'
      path: '/payments/$id'
      fullPath: '/payments/$id/'
      preLoaderRoute: typeof AuthPaymentsIdIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/landed-cost/$id/': {
      id: '/_auth/landed-cost/$id/'
      path: '/landed-cost/$id'
      fullPath: '/landed-cost/$id/'
      preLoaderRoute: typeof AuthLandedCostIdIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/invoices/$id/': {
      id: '/_auth/invoices/$id/'
      path: '/invoices/$id'
      fullPath: '/invoices/$id/'
      preLoaderRoute: typeof AuthInvoicesIdIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/finance/kpn/': {
      id: '/_auth/finance/kpn/'
      path: '/finance/kpn'
      fullPath: '/finance/kpn/'
      preLoaderRoute: typeof AuthFinanceKpnIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/finance/esf/': {
      id: '/_auth/finance/esf/'
      path: '/finance/esf'
      fullPath: '/finance/esf/'
      preLoaderRoute: typeof AuthFinanceEsfIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/docs/$role/': {
      id: '/_auth/docs/$role/'
      path: '/docs/$role'
      fullPath: '/docs/$role/'
      preLoaderRoute: typeof AuthDocsRoleIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/counterparties/$id/': {
      id: '/_auth/counterparties/$id/'
      path: '/counterparties/$id'
      fullPath: '/counterparties/$id/'
      preLoaderRoute: typeof AuthCounterpartiesIdIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/budgets/$id/': {
      id: '/_auth/budgets/$id/'
      path: '/budgets/$id'
      fullPath: '/budgets/$id/'
      preLoaderRoute: typeof AuthBudgetsIdIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/work-tasks/task/$taskId': {
      id: '/_auth/work-tasks/task/$taskId'
      path: '/work-tasks/task/$taskId'
      fullPath: '/work-tasks/task/$taskId'
      preLoaderRoute: typeof AuthWorkTasksTaskTaskIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/work-orders/$id/edit': {
      id: '/_auth/work-orders/$id/edit'
      path: '/work-orders/$id/edit'
      fullPath: '/work-orders/$id/edit'
      preLoaderRoute: typeof AuthWorkOrdersIdEditRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/work-blueprints_/$id_/edit': {
      id: '/_auth/work-blueprints_/$id_/edit'
      path: '/work-blueprints/$id/edit'
      fullPath: '/work-blueprints/$id/edit'
      preLoaderRoute: typeof AuthWorkBlueprintsIdEditRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/stock-reconciliation/$id/edit': {
      id: '/_auth/stock-reconciliation/$id/edit'
      path: '/stock-reconciliation/$id/edit'
      fullPath: '/stock-reconciliation/$id/edit'
      preLoaderRoute: typeof AuthStockReconciliationIdEditRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/stock-entries/$id/edit': {
      id: '/_auth/stock-entries/$id/edit'
      path: '/stock-entries/$id/edit'
      fullPath: '/stock-entries/$id/edit'
      preLoaderRoute: typeof AuthStockEntriesIdEditRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/settlements/$id/edit': {
      id: '/_auth/settlements/$id/edit'
      path: '/settlements/$id/edit'
      fullPath: '/settlements/$id/edit'
      preLoaderRoute: typeof AuthSettlementsIdEditRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/sales-orders/$id/edit': {
      id: '/_auth/sales-orders/$id/edit'
      path: '/sales-orders/$id/edit'
      fullPath: '/sales-orders/$id/edit'
      preLoaderRoute: typeof AuthSalesOrdersIdEditRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/projects/$id/edit': {
      id: '/_auth/projects/$id/edit'
      path: '/projects/$id/edit'
      fullPath: '/projects/$id/edit'
      preLoaderRoute: typeof AuthProjectsIdEditRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/payments/$id/edit': {
      id: '/_auth/payments/$id/edit'
      path: '/payments/$id/edit'
      fullPath: '/payments/$id/edit'
      preLoaderRoute: typeof AuthPaymentsIdEditRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/landed-cost/$id/edit': {
      id: '/_auth/landed-cost/$id/edit'
      path: '/landed-cost/$id/edit'
      fullPath: '/landed-cost/$id/edit'
      preLoaderRoute: typeof AuthLandedCostIdEditRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/invoices/ar/new': {
      id: '/_auth/invoices/ar/new'
      path: '/new'
      fullPath: '/invoices/ar/new'
      preLoaderRoute: typeof AuthInvoicesArNewRouteImport
      parentRoute: typeof AuthInvoicesArRoute
    }
    '/_auth/invoices/ap/new': {
      id: '/_auth/invoices/ap/new'
      path: '/new'
      fullPath: '/invoices/ap/new'
      preLoaderRoute: typeof AuthInvoicesApNewRouteImport
      parentRoute: typeof AuthInvoicesApRoute
    }
    '/_auth/invoices/$id/edit': {
      id: '/_auth/invoices/$id/edit'
      path: '/invoices/$id/edit'
      fullPath: '/invoices/$id/edit'
      preLoaderRoute: typeof AuthInvoicesIdEditRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/finance/regulatory/kpn': {
      id: '/_auth/finance/regulatory/kpn'
      path: '/finance/regulatory/kpn'
      fullPath: '/finance/regulatory/kpn'
      preLoaderRoute: typeof AuthFinanceRegulatoryKpnRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/finance/regulatory/esf': {
      id: '/_auth/finance/regulatory/esf'
      path: '/finance/regulatory/esf'
      fullPath: '/finance/regulatory/esf'
      preLoaderRoute: typeof AuthFinanceRegulatoryEsfRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/finance/kpn/$id': {
      id: '/_auth/finance/kpn/$id'
      path: '/finance/kpn/$id'
      fullPath: '/finance/kpn/$id'
      preLoaderRoute: typeof AuthFinanceKpnIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/finance/esf/$id': {
      id: '/_auth/finance/esf/$id'
      path: '/finance/esf/$id'
      fullPath: '/finance/esf/$id'
      preLoaderRoute: typeof AuthFinanceEsfIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/counterparties/$id/edit': {
      id: '/_auth/counterparties/$id/edit'
      path: '/counterparties/$id/edit'
      fullPath: '/counterparties/$id/edit'
      preLoaderRoute: typeof AuthCounterpartiesIdEditRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/budgets/$id/edit': {
      id: '/_auth/budgets/$id/edit'
      path: '/budgets/$id/edit'
      fullPath: '/budgets/$id/edit'
      preLoaderRoute: typeof AuthBudgetsIdEditRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/admin/integrations_/platform': {
      id: '/_auth/admin/integrations_/platform'
      path: '/integrations/platform'
      fullPath: '/admin/integrations/platform'
      preLoaderRoute: typeof AuthAdminIntegrationsPlatformRouteImport
      parentRoute: typeof AuthAdminRoute
    }
    '/_auth/admin/holdings_/$holdingId': {
      id: '/_auth/admin/holdings_/$holdingId'
      path: '/holdings/$holdingId'
      fullPath: '/admin/holdings/$holdingId'
      preLoaderRoute: typeof AuthAdminHoldingsHoldingIdRouteImport
      parentRoute: typeof AuthAdminRoute
    }
    '/_auth/admin/entities_/$entityId': {
      id: '/_auth/admin/entities_/$entityId'
      path: '/entities/$entityId'
      fullPath: '/admin/entities/$entityId'
      preLoaderRoute: typeof AuthAdminEntitiesEntityIdRouteImport
      parentRoute: typeof AuthAdminRoute
    }
    '/_auth/docs/$role/$slug/': {
      id: '/_auth/docs/$role/$slug/'
      path: '/docs/$role/$slug'
      fullPath: '/docs/$role/$slug/'
      preLoaderRoute: typeof AuthDocsRoleSlugIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/work-tasks/$projectId_/task/$taskId': {
      id: '/_auth/work-tasks/$projectId_/task/$taskId'
      path: '/work-tasks/$projectId/task/$taskId'
      fullPath: '/work-tasks/$projectId/task/$taskId'
      preLoaderRoute: typeof AuthWorkTasksProjectIdTaskTaskIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/docs/$role/$slug/history': {
      id: '/_auth/docs/$role/$slug/history'
      path: '/docs/$role/$slug/history'
      fullPath: '/docs/$role/$slug/history'
      preLoaderRoute: typeof AuthDocsRoleSlugHistoryRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/docs/$role/$slug/edit': {
      id: '/_auth/docs/$role/$slug/edit'
      path: '/docs/$role/$slug/edit'
      fullPath: '/docs/$role/$slug/edit'
      preLoaderRoute: typeof AuthDocsRoleSlugEditRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/admin/users_/$userId/memberships': {
      id: '/_auth/admin/users_/$userId/memberships'
      path: '/users/$userId/memberships'
      fullPath: '/admin/users/$userId/memberships'
      preLoaderRoute: typeof AuthAdminUsersUserIdMembershipsRouteImport
      parentRoute: typeof AuthAdminRoute
    }
    '/_auth/admin/integrations_/connections/$id': {
      id: '/_auth/admin/integrations_/connections/$id'
      path: '/integrations/connections/$id'
      fullPath: '/admin/integrations/connections/$id'
      preLoaderRoute: typeof AuthAdminIntegrationsConnectionsIdRouteImport
      parentRoute: typeof AuthAdminRoute
    }
  }
}

interface AuthAdminRouteChildren {
  AuthAdminApprovalMatrixRoute: typeof AuthAdminApprovalMatrixRoute
  AuthAdminAuditRoute: typeof AuthAdminAuditRoute
  AuthAdminBankImportRoute: typeof AuthAdminBankImportRoute
  AuthAdminEmailTemplatesRoute: typeof AuthAdminEmailTemplatesRoute
  AuthAdminEntitiesRoute: typeof AuthAdminEntitiesRoute
  AuthAdminFxRatesRoute: typeof AuthAdminFxRatesRoute
  AuthAdminHoldingsRoute: typeof AuthAdminHoldingsRoute
  AuthAdminIntegrationsRoute: typeof AuthAdminIntegrationsRoute
  AuthAdminJobsRoute: typeof AuthAdminJobsRoute
  AuthAdminMemoryRoute: typeof AuthAdminMemoryRoute
  AuthAdminSyncStagingRoute: typeof AuthAdminSyncStagingRoute
  AuthAdminTaskAutomationRoute: typeof AuthAdminTaskAutomationRoute
  AuthAdminUsersRoute: typeof AuthAdminUsersRoute
  AuthAdminWarehouseAccessRoute: typeof AuthAdminWarehouseAccessRoute
  AuthAdminIndexRoute: typeof AuthAdminIndexRoute
  AuthAdminEntitiesEntityIdRoute: typeof AuthAdminEntitiesEntityIdRoute
  AuthAdminHoldingsHoldingIdRoute: typeof AuthAdminHoldingsHoldingIdRoute
  AuthAdminIntegrationsPlatformRoute: typeof AuthAdminIntegrationsPlatformRoute
  AuthAdminIntegrationsConnectionsIdRoute: typeof AuthAdminIntegrationsConnectionsIdRoute
  AuthAdminUsersUserIdMembershipsRoute: typeof AuthAdminUsersUserIdMembershipsRoute
}

const AuthAdminRouteChildren: AuthAdminRouteChildren = {
  AuthAdminApprovalMatrixRoute: AuthAdminApprovalMatrixRoute,
  AuthAdminAuditRoute: AuthAdminAuditRoute,
  AuthAdminBankImportRoute: AuthAdminBankImportRoute,
  AuthAdminEmailTemplatesRoute: AuthAdminEmailTemplatesRoute,
  AuthAdminEntitiesRoute: AuthAdminEntitiesRoute,
  AuthAdminFxRatesRoute: AuthAdminFxRatesRoute,
  AuthAdminHoldingsRoute: AuthAdminHoldingsRoute,
  AuthAdminIntegrationsRoute: AuthAdminIntegrationsRoute,
  AuthAdminJobsRoute: AuthAdminJobsRoute,
  AuthAdminMemoryRoute: AuthAdminMemoryRoute,
  AuthAdminSyncStagingRoute: AuthAdminSyncStagingRoute,
  AuthAdminTaskAutomationRoute: AuthAdminTaskAutomationRoute,
  AuthAdminUsersRoute: AuthAdminUsersRoute,
  AuthAdminWarehouseAccessRoute: AuthAdminWarehouseAccessRoute,
  AuthAdminIndexRoute: AuthAdminIndexRoute,
  AuthAdminEntitiesEntityIdRoute: AuthAdminEntitiesEntityIdRoute,
  AuthAdminHoldingsHoldingIdRoute: AuthAdminHoldingsHoldingIdRoute,
  AuthAdminIntegrationsPlatformRoute: AuthAdminIntegrationsPlatformRoute,
  AuthAdminIntegrationsConnectionsIdRoute:
    AuthAdminIntegrationsConnectionsIdRoute,
  AuthAdminUsersUserIdMembershipsRoute: AuthAdminUsersUserIdMembershipsRoute,
}

const AuthAdminRouteWithChildren = AuthAdminRoute._addFileChildren(
  AuthAdminRouteChildren,
)

interface AuthInvoicesApRouteChildren {
  AuthInvoicesApNewRoute: typeof AuthInvoicesApNewRoute
}

const AuthInvoicesApRouteChildren: AuthInvoicesApRouteChildren = {
  AuthInvoicesApNewRoute: AuthInvoicesApNewRoute,
}

const AuthInvoicesApRouteWithChildren = AuthInvoicesApRoute._addFileChildren(
  AuthInvoicesApRouteChildren,
)

interface AuthInvoicesArRouteChildren {
  AuthInvoicesArNewRoute: typeof AuthInvoicesArNewRoute
}

const AuthInvoicesArRouteChildren: AuthInvoicesArRouteChildren = {
  AuthInvoicesArNewRoute: AuthInvoicesArNewRoute,
}

const AuthInvoicesArRouteWithChildren = AuthInvoicesArRoute._addFileChildren(
  AuthInvoicesArRouteChildren,
)

interface AuthRouteChildren {
  AuthAdminRoute: typeof AuthAdminRouteWithChildren
  AuthAnomaliesRoute: typeof AuthAnomaliesRoute
  AuthApprovalsRoute: typeof AuthApprovalsRoute
  AuthBatchesRoute: typeof AuthBatchesRoute
  AuthChatRoute: typeof AuthChatRoute
  AuthConflictsRoute: typeof AuthConflictsRoute
  AuthCostRoute: typeof AuthCostRoute
  AuthDesignSystemRoute: typeof AuthDesignSystemRoute
  AuthEvidenceRoute: typeof AuthEvidenceRoute
  AuthExcelRoute: typeof AuthExcelRoute
  AuthForcePasswordChangeRoute: typeof AuthForcePasswordChangeRoute
  AuthMyDayRoute: typeof AuthMyDayRoute
  AuthNotificationsRoute: typeof AuthNotificationsRoute
  AuthPeriodCloseRoute: typeof AuthPeriodCloseRoute
  AuthReconciliationRoute: typeof AuthReconciliationRoute
  AuthWarehousesRoute: typeof AuthWarehousesRoute
  AuthWorkBlueprintsRoute: typeof AuthWorkBlueprintsRoute
  AuthWriteoffRoute: typeof AuthWriteoffRoute
  AuthIndexRoute: typeof AuthIndexRoute
  AuthBomsBomIdRoute: typeof AuthBomsBomIdRoute
  AuthBomsNewRoute: typeof AuthBomsNewRoute
  AuthBudgetsNewRoute: typeof AuthBudgetsNewRoute
  AuthCounterpartiesNewRoute: typeof AuthCounterpartiesNewRoute
  AuthDocsSearchRoute: typeof AuthDocsSearchRoute
  AuthFinanceCashFlowRoute: typeof AuthFinanceCashFlowRoute
  AuthFinanceCogsRoute: typeof AuthFinanceCogsRoute
  AuthFinanceDashboardRoute: typeof AuthFinanceDashboardRoute
  AuthFinanceOnecPushRoute: typeof AuthFinanceOnecPushRoute
  AuthFinancePnlRoute: typeof AuthFinancePnlRoute
  AuthFinanceSnapshotsRoute: typeof AuthFinanceSnapshotsRoute
  AuthFinanceTaxSummaryRoute: typeof AuthFinanceTaxSummaryRoute
  AuthInvoicesApRoute: typeof AuthInvoicesApRouteWithChildren
  AuthInvoicesArRoute: typeof AuthInvoicesArRouteWithChildren
  AuthInvoicesNewRoute: typeof AuthInvoicesNewRoute
  AuthItemsItemIdRoute: typeof AuthItemsItemIdRoute
  AuthLandedCostNewRoute: typeof AuthLandedCostNewRoute
  AuthMePreferencesRoute: typeof AuthMePreferencesRoute
  AuthMeTaskNotificationsRoute: typeof AuthMeTaskNotificationsRoute
  AuthOnboardingStepRoute: typeof AuthOnboardingStepRoute
  AuthPaymentsNewRoute: typeof AuthPaymentsNewRoute
  AuthProjectsNewRoute: typeof AuthProjectsNewRoute
  AuthRunsRunIdRoute: typeof AuthRunsRunIdRoute
  AuthSalesOrdersNewRoute: typeof AuthSalesOrdersNewRoute
  AuthSettlementsNewRoute: typeof AuthSettlementsNewRoute
  AuthStockEntriesNewRoute: typeof AuthStockEntriesNewRoute
  AuthStockReconciliationNewRoute: typeof AuthStockReconciliationNewRoute
  AuthStockBalanceRoute: typeof AuthStockBalanceRoute
  AuthStockLedgerRoute: typeof AuthStockLedgerRoute
  AuthWorkBlueprintsIdRoute: typeof AuthWorkBlueprintsIdRoute
  AuthWorkOrdersNewRoute: typeof AuthWorkOrdersNewRoute
  AuthWorkTasksProjectIdRoute: typeof AuthWorkTasksProjectIdRoute
  AuthBomsIndexRoute: typeof AuthBomsIndexRoute
  AuthBudgetsIndexRoute: typeof AuthBudgetsIndexRoute
  AuthCounterpartiesIndexRoute: typeof AuthCounterpartiesIndexRoute
  AuthDocsIndexRoute: typeof AuthDocsIndexRoute
  AuthItemsIndexRoute: typeof AuthItemsIndexRoute
  AuthLandedCostIndexRoute: typeof AuthLandedCostIndexRoute
  AuthPaymentsIndexRoute: typeof AuthPaymentsIndexRoute
  AuthProjectsIndexRoute: typeof AuthProjectsIndexRoute
  AuthRunsIndexRoute: typeof AuthRunsIndexRoute
  AuthSalesOrdersIndexRoute: typeof AuthSalesOrdersIndexRoute
  AuthSettlementsIndexRoute: typeof AuthSettlementsIndexRoute
  AuthStockEntriesIndexRoute: typeof AuthStockEntriesIndexRoute
  AuthStockReconciliationIndexRoute: typeof AuthStockReconciliationIndexRoute
  AuthWorkOrdersIndexRoute: typeof AuthWorkOrdersIndexRoute
  AuthWorkTasksIndexRoute: typeof AuthWorkTasksIndexRoute
  AuthBudgetsIdEditRoute: typeof AuthBudgetsIdEditRoute
  AuthCounterpartiesIdEditRoute: typeof AuthCounterpartiesIdEditRoute
  AuthFinanceEsfIdRoute: typeof AuthFinanceEsfIdRoute
  AuthFinanceKpnIdRoute: typeof AuthFinanceKpnIdRoute
  AuthFinanceRegulatoryEsfRoute: typeof AuthFinanceRegulatoryEsfRoute
  AuthFinanceRegulatoryKpnRoute: typeof AuthFinanceRegulatoryKpnRoute
  AuthInvoicesIdEditRoute: typeof AuthInvoicesIdEditRoute
  AuthLandedCostIdEditRoute: typeof AuthLandedCostIdEditRoute
  AuthPaymentsIdEditRoute: typeof AuthPaymentsIdEditRoute
  AuthProjectsIdEditRoute: typeof AuthProjectsIdEditRoute
  AuthSalesOrdersIdEditRoute: typeof AuthSalesOrdersIdEditRoute
  AuthSettlementsIdEditRoute: typeof AuthSettlementsIdEditRoute
  AuthStockEntriesIdEditRoute: typeof AuthStockEntriesIdEditRoute
  AuthStockReconciliationIdEditRoute: typeof AuthStockReconciliationIdEditRoute
  AuthWorkBlueprintsIdEditRoute: typeof AuthWorkBlueprintsIdEditRoute
  AuthWorkOrdersIdEditRoute: typeof AuthWorkOrdersIdEditRoute
  AuthWorkTasksTaskTaskIdRoute: typeof AuthWorkTasksTaskTaskIdRoute
  AuthBudgetsIdIndexRoute: typeof AuthBudgetsIdIndexRoute
  AuthCounterpartiesIdIndexRoute: typeof AuthCounterpartiesIdIndexRoute
  AuthDocsRoleIndexRoute: typeof AuthDocsRoleIndexRoute
  AuthFinanceEsfIndexRoute: typeof AuthFinanceEsfIndexRoute
  AuthFinanceKpnIndexRoute: typeof AuthFinanceKpnIndexRoute
  AuthInvoicesIdIndexRoute: typeof AuthInvoicesIdIndexRoute
  AuthLandedCostIdIndexRoute: typeof AuthLandedCostIdIndexRoute
  AuthPaymentsIdIndexRoute: typeof AuthPaymentsIdIndexRoute
  AuthProjectsIdIndexRoute: typeof AuthProjectsIdIndexRoute
  AuthSalesOrdersIdIndexRoute: typeof AuthSalesOrdersIdIndexRoute
  AuthSettlementsIdIndexRoute: typeof AuthSettlementsIdIndexRoute
  AuthStockEntriesIdIndexRoute: typeof AuthStockEntriesIdIndexRoute
  AuthStockReconciliationIdIndexRoute: typeof AuthStockReconciliationIdIndexRoute
  AuthWorkOrdersIdIndexRoute: typeof AuthWorkOrdersIdIndexRoute
  AuthDocsRoleSlugEditRoute: typeof AuthDocsRoleSlugEditRoute
  AuthDocsRoleSlugHistoryRoute: typeof AuthDocsRoleSlugHistoryRoute
  AuthWorkTasksProjectIdTaskTaskIdRoute: typeof AuthWorkTasksProjectIdTaskTaskIdRoute
  AuthDocsRoleSlugIndexRoute: typeof AuthDocsRoleSlugIndexRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthAdminRoute: AuthAdminRouteWithChildren,
  AuthAnomaliesRoute: AuthAnomaliesRoute,
  AuthApprovalsRoute: AuthApprovalsRoute,
  AuthBatchesRoute: AuthBatchesRoute,
  AuthChatRoute: AuthChatRoute,
  AuthConflictsRoute: AuthConflictsRoute,
  AuthCostRoute: AuthCostRoute,
  AuthDesignSystemRoute: AuthDesignSystemRoute,
  AuthEvidenceRoute: AuthEvidenceRoute,
  AuthExcelRoute: AuthExcelRoute,
  AuthForcePasswordChangeRoute: AuthForcePasswordChangeRoute,
  AuthMyDayRoute: AuthMyDayRoute,
  AuthNotificationsRoute: AuthNotificationsRoute,
  AuthPeriodCloseRoute: AuthPeriodCloseRoute,
  AuthReconciliationRoute: AuthReconciliationRoute,
  AuthWarehousesRoute: AuthWarehousesRoute,
  AuthWorkBlueprintsRoute: AuthWorkBlueprintsRoute,
  AuthWriteoffRoute: AuthWriteoffRoute,
  AuthIndexRoute: AuthIndexRoute,
  AuthBomsBomIdRoute: AuthBomsBomIdRoute,
  AuthBomsNewRoute: AuthBomsNewRoute,
  AuthBudgetsNewRoute: AuthBudgetsNewRoute,
  AuthCounterpartiesNewRoute: AuthCounterpartiesNewRoute,
  AuthDocsSearchRoute: AuthDocsSearchRoute,
  AuthFinanceCashFlowRoute: AuthFinanceCashFlowRoute,
  AuthFinanceCogsRoute: AuthFinanceCogsRoute,
  AuthFinanceDashboardRoute: AuthFinanceDashboardRoute,
  AuthFinanceOnecPushRoute: AuthFinanceOnecPushRoute,
  AuthFinancePnlRoute: AuthFinancePnlRoute,
  AuthFinanceSnapshotsRoute: AuthFinanceSnapshotsRoute,
  AuthFinanceTaxSummaryRoute: AuthFinanceTaxSummaryRoute,
  AuthInvoicesApRoute: AuthInvoicesApRouteWithChildren,
  AuthInvoicesArRoute: AuthInvoicesArRouteWithChildren,
  AuthInvoicesNewRoute: AuthInvoicesNewRoute,
  AuthItemsItemIdRoute: AuthItemsItemIdRoute,
  AuthLandedCostNewRoute: AuthLandedCostNewRoute,
  AuthMePreferencesRoute: AuthMePreferencesRoute,
  AuthMeTaskNotificationsRoute: AuthMeTaskNotificationsRoute,
  AuthOnboardingStepRoute: AuthOnboardingStepRoute,
  AuthPaymentsNewRoute: AuthPaymentsNewRoute,
  AuthProjectsNewRoute: AuthProjectsNewRoute,
  AuthRunsRunIdRoute: AuthRunsRunIdRoute,
  AuthSalesOrdersNewRoute: AuthSalesOrdersNewRoute,
  AuthSettlementsNewRoute: AuthSettlementsNewRoute,
  AuthStockEntriesNewRoute: AuthStockEntriesNewRoute,
  AuthStockReconciliationNewRoute: AuthStockReconciliationNewRoute,
  AuthStockBalanceRoute: AuthStockBalanceRoute,
  AuthStockLedgerRoute: AuthStockLedgerRoute,
  AuthWorkBlueprintsIdRoute: AuthWorkBlueprintsIdRoute,
  AuthWorkOrdersNewRoute: AuthWorkOrdersNewRoute,
  AuthWorkTasksProjectIdRoute: AuthWorkTasksProjectIdRoute,
  AuthBomsIndexRoute: AuthBomsIndexRoute,
  AuthBudgetsIndexRoute: AuthBudgetsIndexRoute,
  AuthCounterpartiesIndexRoute: AuthCounterpartiesIndexRoute,
  AuthDocsIndexRoute: AuthDocsIndexRoute,
  AuthItemsIndexRoute: AuthItemsIndexRoute,
  AuthLandedCostIndexRoute: AuthLandedCostIndexRoute,
  AuthPaymentsIndexRoute: AuthPaymentsIndexRoute,
  AuthProjectsIndexRoute: AuthProjectsIndexRoute,
  AuthRunsIndexRoute: AuthRunsIndexRoute,
  AuthSalesOrdersIndexRoute: AuthSalesOrdersIndexRoute,
  AuthSettlementsIndexRoute: AuthSettlementsIndexRoute,
  AuthStockEntriesIndexRoute: AuthStockEntriesIndexRoute,
  AuthStockReconciliationIndexRoute: AuthStockReconciliationIndexRoute,
  AuthWorkOrdersIndexRoute: AuthWorkOrdersIndexRoute,
  AuthWorkTasksIndexRoute: AuthWorkTasksIndexRoute,
  AuthBudgetsIdEditRoute: AuthBudgetsIdEditRoute,
  AuthCounterpartiesIdEditRoute: AuthCounterpartiesIdEditRoute,
  AuthFinanceEsfIdRoute: AuthFinanceEsfIdRoute,
  AuthFinanceKpnIdRoute: AuthFinanceKpnIdRoute,
  AuthFinanceRegulatoryEsfRoute: AuthFinanceRegulatoryEsfRoute,
  AuthFinanceRegulatoryKpnRoute: AuthFinanceRegulatoryKpnRoute,
  AuthInvoicesIdEditRoute: AuthInvoicesIdEditRoute,
  AuthLandedCostIdEditRoute: AuthLandedCostIdEditRoute,
  AuthPaymentsIdEditRoute: AuthPaymentsIdEditRoute,
  AuthProjectsIdEditRoute: AuthProjectsIdEditRoute,
  AuthSalesOrdersIdEditRoute: AuthSalesOrdersIdEditRoute,
  AuthSettlementsIdEditRoute: AuthSettlementsIdEditRoute,
  AuthStockEntriesIdEditRoute: AuthStockEntriesIdEditRoute,
  AuthStockReconciliationIdEditRoute: AuthStockReconciliationIdEditRoute,
  AuthWorkBlueprintsIdEditRoute: AuthWorkBlueprintsIdEditRoute,
  AuthWorkOrdersIdEditRoute: AuthWorkOrdersIdEditRoute,
  AuthWorkTasksTaskTaskIdRoute: AuthWorkTasksTaskTaskIdRoute,
  AuthBudgetsIdIndexRoute: AuthBudgetsIdIndexRoute,
  AuthCounterpartiesIdIndexRoute: AuthCounterpartiesIdIndexRoute,
  AuthDocsRoleIndexRoute: AuthDocsRoleIndexRoute,
  AuthFinanceEsfIndexRoute: AuthFinanceEsfIndexRoute,
  AuthFinanceKpnIndexRoute: AuthFinanceKpnIndexRoute,
  AuthInvoicesIdIndexRoute: AuthInvoicesIdIndexRoute,
  AuthLandedCostIdIndexRoute: AuthLandedCostIdIndexRoute,
  AuthPaymentsIdIndexRoute: AuthPaymentsIdIndexRoute,
  AuthProjectsIdIndexRoute: AuthProjectsIdIndexRoute,
  AuthSalesOrdersIdIndexRoute: AuthSalesOrdersIdIndexRoute,
  AuthSettlementsIdIndexRoute: AuthSettlementsIdIndexRoute,
  AuthStockEntriesIdIndexRoute: AuthStockEntriesIdIndexRoute,
  AuthStockReconciliationIdIndexRoute: AuthStockReconciliationIdIndexRoute,
  AuthWorkOrdersIdIndexRoute: AuthWorkOrdersIdIndexRoute,
  AuthDocsRoleSlugEditRoute: AuthDocsRoleSlugEditRoute,
  AuthDocsRoleSlugHistoryRoute: AuthDocsRoleSlugHistoryRoute,
  AuthWorkTasksProjectIdTaskTaskIdRoute: AuthWorkTasksProjectIdTaskTaskIdRoute,
  AuthDocsRoleSlugIndexRoute: AuthDocsRoleSlugIndexRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AuthRoute: AuthRouteWithChildren,
  AcceptInviteRoute: AcceptInviteRoute,
  ConfirmEmailChangeRoute: ConfirmEmailChangeRoute,
  LoginRoute: LoginRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  AuthPasswordResetRoute: AuthPasswordResetRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
